<template>
<div class="medicalRecord" @click.stop="pushMxxz(1)">
<div class="head">
  <div class="title">病历</div>
<!--  <div class="addFile" v-if="patient.visitState === '00' || patient.visitState === '01'" @click.stop="showUploadDialog = true">上传附件</div>-->
</div>
  <div class="contentBody">
    <div :class="(patient.visitState === '00' || patient.visitState === '01') || isEdit ? 'content' : 'contentNone'">

      <div class="noneMarsk" v-if="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit"></div>
      <el-form :model="medicalRecordInfo" :rules="formRules === 1?medicalRecordInfoRules:medicalRecordInfoRules2" ref="medicalRecordInfo" label-width="0" class="demo-ruleForm" :validate-on-rule-change="false">
        <div class="card">
          <el-form-item prop="readme" :show-message="false">
            <div class="row">
              <div class="labelBox">
                <div class="label"><span class="must">*</span>主诉</div>
              </div>
              <div class="input-wrapper" style="flex: 1">
                <el-input placeholder="请输入患者最感痛苦的症状、体征" @focus="zsFocus = true" @blur="zsFocus = false" @input="handleReadmeInput" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"  ref="zsInput"   v-model="medicalRecordInfo.readme"/>
              </div>
              <div class="timeSelect">
                <div class="dateLabel" @click.stop="showDatePicker = true">发病日期 {{medicalRecordInfo.dateOfOnSet}}<i class="el-icon-caret-bottom"></i></div>
                <div class="pickerBox">
                  <el-date-picker
                      :picker-options="{disabledDate: (time) => time.getTime() > Date.now()}"
                      :clearable="false"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      v-model="medicalRecordInfo.dateOfOnSet"
                      type="date"
                      placeholder=""
                      v-show="showDatePicker"
                      @close="showDatePicker = false"
                      ref="datePickerRef">
                  </el-date-picker>
                </div>
              </div>
            </div>
          </el-form-item>
          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="zsFocus" @close="closeSelectPop"  :dataList="zsSelectList" :inputValue="medicalRecordInfo.readme" v-if="zsFocus" />
          </div>
          <el-form-item prop="present" :show-message="false">
            <div class="row">
              <div class="labelBox">
                <div class="label"><span class="must">*</span>病程</div>
              </div>
              <el-input placeholder="请输入患者从发病到结束的过程及时间" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput"  v-model="medicalRecordInfo.present"/>
            </div>
          </el-form-item>
          <div class="parentBox">
            <div class="leftParent">
              现病史
            </div>
            <div class="rightChildrenBox">
              <div class="row">
                <div class="labelBox">
                  <div class="label"><span class="must">*</span>饮食</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="diet" :show-message="false">
                    <el-input placeholder="请输入患者的食欲、口味偏好等信息" :autosize="dietAutosize" @input="updateAutosizeForMedicalGroup(['diet','sleepChronicles'])" type="textarea" ref="dietInput" @focus="ysFocus = true" @blur="ysFocus = false" v-model="medicalRecordInfo.diet"/>
                  </el-form-item>
                </div>
                <div class="labelBox">
                  <div class="label" style="border-left: 1px solid #e0e5ee;"><span class="must">*</span>睡眠</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="sleepChronicles" :show-message="false">
                    <el-input  placeholder="请输入患者的入睡情况、睡眠深度等信息" :autosize="sleepAutosize" @input="updateAutosizeForMedicalGroup(['diet','sleepChronicles'])"  @focus="mzFocus = true" @blur="mzFocus = false" type="textarea"  ref="sleepInput"   v-model="medicalRecordInfo.sleepChronicles"/>
                  </el-form-item>
                </div>
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="ysFocus" @close="closeSelectPop" :dataList="ysSelectList" :inputValue="medicalRecordInfo.diet" v-if="ysFocus" />
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="mzFocus" @close="closeSelectPop" :dataList="mzSelectList" :inputValue="medicalRecordInfo.sleepChronicles" v-if="mzFocus" />
              </div>
              <div class="row">
                <div class="labelBox">
                  <div class="label"><span class="must">*</span>小便</div>
                </div>

                <div class="input-wrapper">
                  <el-form-item prop="urinate" :show-message="false">
                    <el-input placeholder="请输入患者的小便频次、颜色等信息'" style="border-right: 1px solid  #e0e5ee" :autosize="urinateAutosize" @input="updateAutosizeForMedicalGroup(['urinate','stool'])" type="textarea" ref="urinateInput" @focus="xbFocus = true" @blur="xbFocus = false" v-model="medicalRecordInfo.urinate"/>
                  </el-form-item>
                </div>
                <div class="labelBox">
                  <div class="label" style="border-left: 1px solid #e0e5ee;"><span class="must">*</span>大便</div>
                </div>

                <div class="input-wrapper">
                  <el-form-item prop="stool" :show-message="false">
                    <el-input placeholder="请输入患者的大便频次、性状等信息" :autosize="stoolAutosize" @input="updateAutosizeForMedicalGroup(['urinate','stool'])" type="textarea" ref="stoolInput" @focus="dbFocus = true" @blur="dbFocus = false" v-model="medicalRecordInfo.stool"/>
                  </el-form-item>
                </div>
              </div>

              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="xbFocus" @close="closeSelectPop" :dataList="xbSelectList" :inputValue="medicalRecordInfo.urinate" v-if="xbFocus" />
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="dbFocus" @close="closeSelectPop" :dataList="dbSelectList" :inputValue="medicalRecordInfo.stool" v-if="dbFocus" />
              </div>
              <div class="row">
                <div class="labelBox">
                  <div class="label"><span class="must">*</span>情志</div>
                </div>

                <div class="input-wrapper">
                  <el-form-item prop="emotion" :show-message="false">
                    <div class="input-wrapper">
                      <el-input placeholder="请输入患者的近期情绪状态等信息" :autosize="emotionAutosize" @input="updateAutosizeForMedicalGroup(['emotion','period'])"  @focus="emotionFocus = true" @blur="emotionFocus = false" type="textarea"  ref="emotionInput"   v-model="medicalRecordInfo.emotion"/>
                    </div>
                  </el-form-item>
                </div>
                <div class="labelBox" v-if="patient.gender === 'NV'">
                  <div class="label" style="border-left: 1px solid #e0e5ee;" ><span class="must">*</span>经期</div>
                </div>

                <div class="input-wrapper" v-if="patient.gender === 'NV'">
                  <el-form-item prop="period" :show-message="false">
                    <el-input placeholder="请输入患者的月经情况。如未行经或已绝经，请注明" :autosize="periodAutosize" @input="updateAutosizeForMedicalGroup(['emotion','period'])" type="textarea" ref="periodInput" @focus="jqFocus = true" @blur="jqFocus = false" v-model="medicalRecordInfo.period"/>
                  </el-form-item>
                </div>
              </div>

              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="jqFocus" @close="closeSelectPop" :dataList="jqSelectList" :inputValue="medicalRecordInfo.period" v-if="jqFocus" />
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="emotionFocus" @close="closeSelectPop" :dataList="emotionSelectList" :inputValue="medicalRecordInfo.emotion" v-if="emotionFocus" />
              </div>
              <div class="row">
                <div class="labelBox">
                  <div class="label">汗出</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="sweating" :show-message="false">
                    <el-input placeholder="请输入患者的出汗多少、部位等信息" :autosize="sweatingAutosize" @input="updateAutosizeForMedicalGroup(['sweating','coldAndHeat'])" type="textarea" ref="sweatingInput" @focus="hcFocus = true" @blur="hcFocus = false" v-model="medicalRecordInfo.sweating"/>
                  </el-form-item>
                </div>
                <div class="labelBox">
                  <div class="label" style="border-left: 1px solid #e0e5ee;">寒热</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="coldAndHeat" :show-message="false">
                    <el-input placeholder="请输入患者有无怕冷、发热等信息" :autosize="coldAndHeatAutosize" @input="updateAutosizeForMedicalGroup(['sweating','coldAndHeat'])" type="textarea" ref="coldAndHeatInput" @focus="hrFocus = true" @blur="hrFocus = false" v-model="medicalRecordInfo.coldAndHeat"/>
                  </el-form-item>
                </div>
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="hrFocus" @close="closeSelectPop" :dataList="hrSelectList" :inputValue="medicalRecordInfo.coldAndHeat" v-if="hrFocus" />
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="hcFocus" @close="closeSelectPop" :dataList="hcSelectList" :inputValue="medicalRecordInfo.sweating" v-if="hcFocus" />
              </div>
              <el-form-item prop="presentOther" :show-message="false">
                <div class="row">
                  <div class="labelBox">
                    <div class="label">其他</div>
                  </div>
                  <el-input placeholder="请输入患者现病史其他补充信息" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="presentOtherInput"  v-model="medicalRecordInfo.presentOther"/>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="parentBox">
            <div class="leftParent">
              既往史
            </div>
            <div class="rightChildrenBox">
              <div class="row">
                <div class="labelBox">
                  <div class="label"><span class="must">*</span>曾服用药</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="takenMedications" :show-message="false">
                    <el-input placeholder="默认‘无’，如有可手动输入" :autosize="takenMedicationsAutosize" @input="updateAutosizeForMedicalGroup(['takenMedications','history'])" type="textarea" ref="takenMedicationsInput"  v-model="medicalRecordInfo.takenMedications"/>
                  </el-form-item>
                </div>
                <div class="labelBox">
                  <div class="label" style="border-left: 1px solid #e0e5ee;">既往有</div>
                </div>

                <div class="input-wrapper">
                  <el-form-item prop="history" :show-message="false">
                    <el-input placeholder="请输入患者既往患病信息" :autosize="historyAutosize" @input="updateAutosizeForMedicalGroup(['takenMedications','history'])" type="textarea" ref="jwsInput" @focus="jwsFocus = true" @blur="jwsFocus = false"  v-model="medicalRecordInfo.history"/>
                  </el-form-item>
                </div>
              </div>

              <div class="popBox" @mousedown.prevent>
                <selectPop @getValue="getValue" popKey="jwsFocus" @close="closeSelectPop" :dataList="jwySelectList" :inputValue="medicalRecordInfo.history" v-if="jwsFocus" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="labelBox">
              <div class="label"><span class="must">*</span>家族史</div>
            </div>

            <div class="input-wrapper">
              <el-form-item prop="familyHistory" :show-message="false">
                <el-input placeholder="默认'无’，如有可手动输入" :autosize="familyHistoryAutosize" @input="updateAutosizeForMedicalGroup(['familyHistory','allergy','personalHistory'])" type="textarea" ref="familyHistoryInput" @focus="jzsFocus = true" @blur="jzsFocus = false" v-model="medicalRecordInfo.familyHistory"/>
              </el-form-item>
            </div>
            <div class="labelBox">
              <div class="label" style="border-left: 1px solid #e0e5ee;"><span class="must">*</span>过敏史</div>
            </div>
            <div class="input-wrapper">
              <el-form-item prop="allergy" :show-message="false">
                <el-input placeholder="默认'无’，如有可手动输入" :autosize="allergyAutosize" @input="updateAutosizeForMedicalGroup(['familyHistory','allergy','personalHistory'])" type="textarea" ref="allergyInput" @focus="gmsFocus = true" @blur="gmsFocus = false" v-model="medicalRecordInfo.allergy"/>
              </el-form-item>
            </div>
            <div class="labelBox">
              <div class="label" style="border-left: 1px solid #e0e5ee;"><span class="must">*</span>个人史</div>
            </div>
            <div class="input-wrapper">
              <el-form-item prop="personalHistory" :show-message="false">
                <el-input placeholder="默认'无’，如有可手动输入" :autosize="personalHistoryAutosize" @input="updateAutosizeForMedicalGroup(['familyHistory','allergy','personalHistory'])" type="textarea" ref="personalHistoryInput" @focus="grsFocus = true" @blur="grsFocus = false" v-model="medicalRecordInfo.personalHistory"/>
              </el-form-item>
            </div>
          </div>
          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="jzsFocus" @close="closeSelectPop" :dataList="jzsSelectList" :inputValue="medicalRecordInfo.familyHistory" v-if="jzsFocus" />
          </div>
          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="gmsFocus" @close="closeSelectPop" :dataList="gmsSelectList" :inputValue="medicalRecordInfo.allergy" v-if="gmsFocus" />
          </div>
          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="grsFocus" @close="closeSelectPop" :dataList="grsSelectList" :inputValue="medicalRecordInfo.personalHistory" v-if="grsFocus" />
          </div>
          <div class="parentBox">
            <div class="leftParent">
              <span class="must">*</span>望切
            </div>
            <div class="rightChildrenBox">
              <div class="row">
                <div class="labelBox">
                  <div class="label"><span class="must">*</span>舌诊</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="tongueDiagnosis" :show-message="false">
                    <el-input placeholder="请输入患者的舌色、苔质等信息" :autosize="tongueDiagnosisAutosize" @input="updateAutosizeForMedicalGroup(['tongueDiagnosis','pulseDiagnosis'])" type="textarea" ref="xuetangInput" @focus="shezhenFocus = true" @blur="shezhenFocus = false" v-model="medicalRecordInfo.tongueDiagnosis"/>
                  </el-form-item>
                </div>
                <div class="labelBox">
                  <div class="label" style="border-left: 1px solid #e0e5ee;"><span class="must">*</span>脉诊</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="pulseDiagnosis" :show-message="false">
                    <el-input placeholder="请输入患者的脉象信息" :autosize="pulseDiagnosisAutosize" @input="updateAutosizeForMedicalGroup(['tongueDiagnosis','pulseDiagnosis'])" type="textarea" ref="maizhenInput" @focus="maizhenFocus = true" @blur="maizhenFocus = false" v-model="medicalRecordInfo.pulseDiagnosis"/>
                  </el-form-item>
                </div>
                <div class="wwqz" @click.stop.stop="mxxzFocus = true">
                  <i class="el-icon-thumb"></i>
                  <span>脉象选择</span>
                  <div class="mxxzPop" v-if="mxxzFocus">
                    <div class="contentBox">
                      <div class="row">
                        <div :class="mxxzSelectList.includes('左')?'itemed':'item'" @click.stop="addMxxz('左')">左</div>
                        <div :class="mxxzSelectList.includes('右')?'itemed':'item'" @click.stop="addMxxz('右')">右</div>
                      </div>
                      <div class="row">
                        <div :class="mxxzSelectList.includes('寸')?'itemed':'item'" @click.stop="addMxxz('寸')">寸</div>
                        <div :class="mxxzSelectList.includes('关')?'itemed':'item'" @click.stop="addMxxz('关')">关</div>
                        <div :class="mxxzSelectList.includes('尺')?'itemed':'item'" @click.stop="addMxxz('尺')">尺</div>
                      </div>
                      <div class="row">
                        <div :class="mxxzSelectList.includes('浮')?'itemed':'item'" @click.stop="addMxxz('浮')">浮</div>
                        <div :class="mxxzSelectList.includes('沉')?'itemed':'item'" @click.stop="addMxxz('沉')">沉</div>
                        <div :class="mxxzSelectList.includes('迟')?'itemed':'item'" @click.stop="addMxxz('迟')">迟</div>
                        <div :class="mxxzSelectList.includes('数')?'itemed':'item'" @click.stop="addMxxz('数')">数</div>
                        <div :class="mxxzSelectList.includes('虚')?'itemed':'item'" @click.stop="addMxxz('虚')">虚</div>
                        <div :class="mxxzSelectList.includes('实')?'itemed':'item'" @click.stop="addMxxz('实')">实</div>
                      </div>
                      <div class="row">
                        <div :class="mxxzSelectList.includes('濡')?'itemed':'item'" @click.stop="addMxxz('濡')">濡</div>
                        <div :class="mxxzSelectList.includes('弱')?'itemed':'item'" @click.stop="addMxxz('弱')">弱</div>
                        <div :class="mxxzSelectList.includes('缓')?'itemed':'item'" @click.stop="addMxxz('缓')">缓</div>
                        <div :class="mxxzSelectList.includes('促')?'itemed':'item'" @click.stop="addMxxz('促')">促</div>
                        <div :class="mxxzSelectList.includes('细')?'itemed':'item'" @click.stop="addMxxz('细')">细</div>
                        <div :class="mxxzSelectList.includes('弦')?'itemed':'item'" @click.stop="addMxxz('弦')">弦</div>
                      </div>
                      <div class="row">
                        <div :class="mxxzSelectList.includes('洪')?'itemed':'item'" @click.stop="addMxxz('洪')">洪</div>
                        <div :class="mxxzSelectList.includes('伏')?'itemed':'item'" @click.stop="addMxxz('伏')">伏</div>
                        <div :class="mxxzSelectList.includes('涩')?'itemed':'item'" @click.stop="addMxxz('涩')">涩</div>
                        <div :class="mxxzSelectList.includes('动')?'itemed':'item'" @click.stop="addMxxz('动')">动</div>
                        <div :class="mxxzSelectList.includes('微')?'itemed':'item'" @click.stop="addMxxz('微')">微</div>
                        <div :class="mxxzSelectList.includes('滑')?'itemed':'item'" @click.stop="addMxxz('滑')">滑</div>
                      </div>
                      <div class="row">
                        <div :class="mxxzSelectList.includes('芤')?'itemed':'item'" @click.stop="addMxxz('芤')">芤</div>
                        <div :class="mxxzSelectList.includes('牢')?'itemed':'item'" @click.stop="addMxxz('牢')">牢</div>
                        <div :class="mxxzSelectList.includes('结')?'itemed':'item'" @click.stop="addMxxz('结')">结</div>
                        <div :class="mxxzSelectList.includes('疾')?'itemed':'item'" @click.stop="addMxxz('疾')">疾</div>
                        <div :class="mxxzSelectList.includes('代')?'itemed':'item'" @click.stop="addMxxz('代')">代</div>
                        <div :class="mxxzSelectList.includes('紧')?'itemed':'item'" @click.stop="addMxxz('紧')">紧</div>
                      </div>
                      <div class="row">
                        <div :class="mxxzSelectList.includes('革')?'itemed':'item'" @click.stop="addMxxz('革')">革</div>
                        <div :class="mxxzSelectList.includes('散')?'itemed':'item'" @click.stop="addMxxz('散')">散</div>
                        <div :class="mxxzSelectList.includes('短')?'itemed':'item'" @click.stop="addMxxz('短')">短</div>
                        <div :class="mxxzSelectList.includes('长')?'itemed':'item'" @click.stop="addMxxz('长')">长</div>
                      </div>
                    </div>
                    <div class="showBox">
                      <div class="selectValue">
                        <span v-for="item in mxxzSelectList">{{item}}</span>
                      </div>
                      <el-button @click.stop="pushMxxz()" class="ok" type="success" style="border-radius: 20px">确定</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="shezhenFocus" @close="closeSelectPop" :dataList="shezhenSelectList" :inputValue="medicalRecordInfo.tongueDiagnosis" v-if="shezhenFocus" />
              </div>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="maizhenFocus" @close="closeSelectPop" :dataList="maizhenSelectList" :inputValue="medicalRecordInfo.pulseDiagnosis" v-if="maizhenFocus" />
              </div>
              <el-form-item prop="observationDiagnosis" :show-message="false">
                <div class="row">
                  <div class="labelBox">
                    <div class="label">面诊</div>
                  </div>
                  <div  class="input-wrapper">
                    <el-input placeholder="请输入患者的面部颜色、光泽等信息" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"  @focus="wwqzFocus = true" @blur="wwqzFocus = false" v-model="medicalRecordInfo.observationDiagnosis"/>
                  </div>
                </div>
                <div class="popBox" @mousedown.prevent>
                  <selectPop @getValue="getValue" popKey="wwqzFocus" @close="closeSelectPop" :dataList="mianzhenSelectList" :inputValue="medicalRecordInfo.observationDiagnosis" v-if="wwqzFocus" />
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="row">
            <div class="labelBox">
              <div class="label">出生史</div>
            </div>
            <div class="input-wrapper">
              <el-form-item prop="birthHistory" :show-message="false">
                <el-input placeholder="请输入患者的围产、出生等信息" :autosize="birthHistoryAutosize" @input="updateAutosizeForMedicalGroup(['birthHistory','epidemics'])" type="textarea" ref="birthHistoryInput" @focus="cssFocus = true" @blur="cssFocus = false" v-model="medicalRecordInfo.birthHistory"/>
              </el-form-item>
            </div>
            <div class="labelBox">
              <div class="label" style="border-left: 1px solid #e0e5ee;">流行病史</div>
            </div>

            <div class="input-wrapper">
              <el-form-item prop="epidemics" :show-message="false">
                <el-input placeholder="请输入患者曾患传染病等信息" :autosize="epidemicsAutosize" @input="updateAutosizeForMedicalGroup(['birthHistory','epidemics'])" type="textarea" ref="epidemicsInput" v-model="medicalRecordInfo.epidemics"/>
              </el-form-item>
            </div>
          </div>

          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="cssFocus" @close="closeSelectPop" :dataList="cssSelectList" :inputValue="medicalRecordInfo.birthHistory" v-if="cssFocus" />
          </div>
          <div class="row">
            <div class="labelBox">
              <div class="label">体格检查</div>
            </div>
            <div class="input-wrapper">
              <el-form-item prop="physique" :show-message="false">
                <el-input placeholder="请输入患者的体征、提问等信息" @focus="tgjcFocus = true" @blur="tgjcFocus = false" :autosize="physiqueAutosize" @input="updateAutosizeForMedicalGroup(['physique','auxiliaryExamination'])" type="textarea" ref="tgjcInput"  v-model="medicalRecordInfo.physique"/>
              </el-form-item>
            </div>
            <div class="labelBox">
              <div class="label" style="border-left: 1px solid #e0e5ee;">西医检查</div>
            </div>
            <div class="input-wrapper">
              <el-form-item prop="auxiliaryExamination" :show-message="false">
                <el-input placeholder="请输入患者的西医检查结果" :autosize="auxiliaryExaminationAutosize" @input="updateAutosizeForMedicalGroup(['physique','auxiliaryExamination'])" type="textarea" ref="auxiliaryExaminationInput" v-model="medicalRecordInfo.auxiliaryExamination"/>
              </el-form-item>
            </div>
          </div>

          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="tgjcFocus" @close="closeSelectPop" :dataList="tgjcSelectList" :inputValue="medicalRecordInfo.physique" v-if="tgjcFocus" />
          </div>
          <div class="parentBox" v-if="0">
            <div class="leftParent">
              体格检查
            </div>
            <div class="rightChildrenBox">
              <el-form-item prop="weight" :show-message="false">
                <div class="row">
                  <div class="label"><span class="must">*</span>体重</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput" @focus="tzFocus = true" @blur="tzFocus = false" v-model="medicalRecordInfo.weight"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="tzFocus" @close="closeSelectPop" :dataList="tzSelectList" :inputValue="medicalRecordInfo.weight" v-if="tzFocus" />
              </div>
              <el-form-item prop="height" :show-message="false">
                <div class="row">
                  <div class="label"><span class="must">*</span>身高</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput" @focus="sgFocus = true" @blur="sgFocus = false" v-model="medicalRecordInfo.height"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="sgFocus" @close="closeSelectPop" :dataList="sgSelectList" :inputValue="medicalRecordInfo.height" v-if="sgFocus" />
              </div>
              <el-form-item prop="physique" :show-message="false">
                <div class="row">
                  <div class="label">体征</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" @focus="tgjcFocus = true" @blur="tgjcFocus = false" v-model="medicalRecordInfo.physique"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop @getValue="getValue" popKey="tgjcFocus" @close="closeSelectPop" :dataList="tgjcSelectList" :inputValue="medicalRecordInfo.physique" v-if="tgjcFocus" />
              </div>
              <el-form-item prop="bodyTemperature" :show-message="false">
                <div class="row">
                  <div class="label">体温</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput" @focus="tiwenFocus = true" @blur="tiwenFocus = false" v-model="medicalRecordInfo.bodyTemperature"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="tiwenFocus" @close="closeSelectPop" :dataList="tiwenSelectList" :inputValue="medicalRecordInfo.bodyTemperature" v-if="tiwenFocus" />
              </div>
              <el-form-item prop="pulseRate" :show-message="false">
                <div class="row">
                  <div class="label">脉搏</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput" @focus="maiboFocus = true" @blur="maiboFocus = false" v-model="medicalRecordInfo.pulseRate"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="maiboFocus" @close="closeSelectPop" :dataList="maiboSelectList" :inputValue="medicalRecordInfo.pulseRate" v-if="maiboFocus" />
              </div>
              <el-form-item prop="breathing" :show-message="false">
                <div class="row">
                  <div class="label">呼吸</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput" @focus="huxiFocus = true" @blur="huxiFocus = false" v-model="medicalRecordInfo.breathing"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="huxiFocus" @close="closeSelectPop" :dataList="huxiSelectList" :inputValue="medicalRecordInfo.breathing" v-if="huxiFocus" />
              </div>
              <el-form-item prop="bloodPressure" :show-message="false">
                <div class="row">
                  <div class="label">血压</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xbsInput" @focus="xueyaFocus = true" @blur="xueyaFocus = false" v-model="medicalRecordInfo.bloodPressure"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="xueyaFocus" @close="closeSelectPop" :dataList="xueyaSelectList" :inputValue="medicalRecordInfo.bloodPressure" v-if="xueyaFocus" />
              </div>
              <el-form-item prop="bloodOxygen" :show-message="false">
                <div class="row">
                  <div class="label">血氧</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xueyangInput" @focus="xueyangFocus = true" @blur="xueyangFocus = false" v-model="medicalRecordInfo.bloodOxygen"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="xueyangFocus" @close="closeSelectPop" :dataList="xueyangSelectList" :inputValue="medicalRecordInfo.bloodOxygen" v-if="xueyangFocus" />
              </div>
              <el-form-item prop="bloodGlucose" :show-message="false">
                <div class="row">
                  <div class="label">血糖</div>
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" ref="xuetangInput" @focus="xuetangFocus = true" @blur="xuetangFocus = false" v-model="medicalRecordInfo.bloodGlucose"/>
                </div>
              </el-form-item>
              <div class="popBox" @mousedown.prevent>
                <selectPop  @getValue="getValue" popKey="xuetangFocus" @close="closeSelectPop" :dataList="xuetangSelectList" :inputValue="medicalRecordInfo.bloodGlucose" v-if="xuetangFocus" />
              </div>
            </div>
          </div>
          <el-form-item prop="mainSymptoms" :show-message="false">
            <div class="row" style="border-radius:0 0 10px 10px;">
              <div class="labelBox">
                <div class="label"><span class="must">*</span>主症</div>
              </div>
              <div class="input-wrapper">
                <el-input placeholder="请输入本次医生重点想解决的症状" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"    v-model="medicalRecordInfo.mainSymptoms"/>
              </div>
            </div>
          </el-form-item>
          <!--      <el-form-item prop="history" :show-message="false">-->
          <!--        <div class="row">-->
          <!--          <div class="label">既往史</div>-->
          <!--          <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" @focus="jwsFocus = true" @blur="jwsFocus = false" v-model="medicalRecordInfo.history"/>-->
          <!--          <div class="popBox" @mousedown.prevent>-->
          <!--            <selectPop @getValue="getValue" popKey="jwsFocus" @close="closeSelectPop" :dataList="jwsSelectList" v-if="jwsFocus" />-->
          <!--          </div>-->
          <!--        </div>-->
          <!--      </el-form-item>-->
          <el-form-item prop="oralExamination" :show-message="false" v-if="0">
            <div class="row">
              <div class="labelBox">
                <div class="label">口腔检查</div>
              </div>
              <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" @focus="kqjcFocus = true" @blur="kqjcFocus = false" v-model="medicalRecordInfo.oralExamination"/>
            </div>
          </el-form-item>
          <div class="popBox" @mousedown.prevent>
            <selectPop @getValue="getValue" popKey="kqjcFocus" @close="closeSelectPop" :dataList="kqjcSelectList" :inputValue="medicalRecordInfo.oralExamination" v-if="kqjcFocus" />
          </div>

          <div class="row" v-if="0">
            <div class="labelBox">
              <div class="label">目标</div>
            </div>

            <div class="input-wrapper">
              <el-form-item prop="target" :show-message="false">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="medicalRecordInfo.target"/>
              </el-form-item>
            </div>
            <div class="labelBox">
              <div class="label">预后</div>
            </div>
            <div class="input-wrapper">
              <el-form-item prop="prognosis" :show-message="false">
                <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"  v-model="medicalRecordInfo.prognosis"/>
              </el-form-item>
            </div>
          </div>
          <div class="row" v-if="0">
            <div class="label">附件</div>
            <div class="uploadBox">
              <div class="fileListItem" v-for="file in fileList" :key="file.id" v-if="fileList.length!==0" @mouseenter="file.showClose = true" @mouseleave="file.showClose = false">
                <div class="imgBox" v-if="file.contentType !== 'application/pdf'">
                  <div class="close" v-show="file.showClose" @click.stop="deleteFileById(file.id)">
                    <i class="el-icon-error"></i>
                  </div>
                  <img  :src="file.src" alt="" class="src" @click.stop="openFile(file)">
                </div>
                <div class="imgBox" v-else>
                  <div class="close" v-show="file.showClose" @click.stop="deleteFileById(file.id)">
                    <i class="el-icon-error"></i>
                  </div>
                  <img  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQKADAAQAAAABAAAAQAAAAABGUUKwAAAD9klEQVR4Ae1bPSwsURT+Zteu/+c3IkRCwWs0NBpEIxokotGJRiMSETX7GlEoVAoSjUgkEoWgEQ1CiAJR+E9QEJFXPBv2Z3bmzR1mdnbtGtfM7s7uzG3uPfeeO/ec7373nNnduwyiFH57m48yZJTuP0xTk0urMTatD0jg/DFhkzQDkKbqQGOjqkpcFXZ23pdjGIDnCQjQwoTkZcDv3wABAdDEhOQFoLgY0AGE5AWA7L0OIKjHALKQsjw+KqXYt0tLv16DgEDK+fmPYkJyM+DddU1MoGeA2o5IRsW7/iETUoMBEtg/iAmpBQABghKE1AOAEgT6GGCULCC9EUr0/7oeE4ZdkVRSkwGRPI3SR8+ARGcB2s8mKkwxPQMsAKIcDdN008eAeGcB2q2gjFGmPwL0DKBEmHYD461vegZYAMSbckZbjz4GWFnAaHuozR56BlhZQBviRpttZQGj7Ui87RF/W1Iu+re21ui/CivNpW4Xnp6G+GwdAWoIU2yCxYAU21Bqd+hfhCIs4ezuRrbLFTLCv74icHaGt+lpsPv74lgkPe7pSdTzra/Dt7YmP4PJzUX+7q4shzfcQ0Pwb26Gd1PLMTsCTFYW0urrkTM7C0dzc1TDbCUl4nj2xASyxselSw9R9fUe0IUBklG8z4d/XV2AwwFnSwvSe3thKyhA5sgI/Ftbkhp4vx/u/n7AZoO9shLpPT2wV1cjvaMDrLDrvtVVWZc03qamwB4fh/QFrq5C5J8KugIAjgN3dyfa4rm+FoHIHBiAvaoKTF5e0MZAAOzhoSizBwfwrqzg18IC7DU1yBgc/ARA4PJS1g8+RJ9WzI4AMY89OZGtZIqK5PanhscDz9yc2G0vKwNTWPhJJVYd+jIgzEpna6vYw7MsuPt7oK4uTCMosuSGx0exVVSAu7mRRDja2kR2SB282w3v4qIkaqr1BSAtDZnDw4BQOxoaZKN9y8uAcO6/LELWkAoJoMqS3tmpFMEJX8oYEgBGcDyjry/EWK8Q0F4nJ0P6Igm28nK5m7u9lduk4RUADCgYQRigV9GVASS6v46OirbxLy8IXFyAe3j4lq1Okj2EQpwjc5icHHkeyffKLCIP6NDQFQAI0T08hanZSHaepEFne7uo+jYzQ257qU3TbVxfAL5pFpORgfyjI/GlhxHeBaTi39uDd35eEuNSJwQA4hljt4sOcs/PIHnet7EB39JSXJxWLhLy5QAZsL4QUcJjgnbwAJrA2UguWgBEQsVMfZ+CoOS8/J8h2ltZ0gOMUn/cEhP+VRLRV+sIGGWjEmWH6RlA/yZo3Q9IFFljsy49A6z7AbHZiUQ91fRB0PQAqMcAlfv2iaKuXuuangH/AWNwItcdMzC6AAAAAElFTkSuQmCC" alt="" @click.stop="openFile(file)">
                </div>
              </div>
              <div class="uploadBtn" @click.stop="showUploadDialog = true">+</div>
            </div>
          </div>
        </div>
        <div class="aiResultGroup" v-for="(item,index) in aiResultList" v-if="herbalPrescriptionInfo.length > 0" :key="index" >
          <div class="aiCard">
            <div class="row" style="overflow:hidden;border-radius: 10px 10px 0 0;">
              <div class="labelBox">
                <div class="label">辨证要点</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="dialecticalGovernance" :show-message="false">
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.dialecticalGovernance"/>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <div class="labelBox">
                <div class="label">体质</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="constitution" :show-message="false">
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.constitution"/>
                </el-form-item>
              </div>
            </div>
             <div class="row">
               <div class="labelBox">
                 <div class="label">病症</div>
               </div>
               <div class="input-wrapper">
                 <el-form-item prop="diagnosis" :show-message="false">
                   <el-input
                     ref="diagnosisInput"
                     :autosize="diagnosisAutosizeList[index]"
                     type="textarea"
                     v-model="item.diagnosis"
                     @input="(val)=>handleDiagnosisInput(val, index)"/>
                 </el-form-item>
               </div>
                 <div class="labelBox">
                   <div class="label" style="border-left: 1px solid #e0e5ee;">辨证</div>
                 </div>
                 <div class="input-wrapper">
                   <el-form-item prop="dialectic" :show-message="false">
                     <el-input
                       ref="bzInput"
                       :autosize="dialecticAutosizeList[index]"
                       type="textarea"
                       v-model="item.dialectic"
                       @input="(val)=>handleDialecticInput(val, index)"/>
                   </el-form-item>
                 </div>
             </div>
              <div class="row">
                <div class="labelBox">
                  <div class="label">治法</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="therapy" :show-message="false">
                  <el-input
                    ref="therapyInput"
                    :autosize="therapyAutosizeList[index]"
                    type="textarea"
                    v-model="item.therapy"
                    @input="(val)=>handleTherapyInput(val, index)"/>
                  </el-form-item>
                </div>
                <div class="labelBox">
                  <div class="label" style="border-left: 1px solid #e0e5ee;">方药</div>
                </div>
                <div class="input-wrapper">
                  <el-form-item prop="prescriptionMedicine" :show-message="false">
                  <el-input
                    ref="prescriptionInput"
                    :autosize="prescriptionAutosizeList[index]"
                    type="textarea"
                    v-model="item.prescriptionMedicine"
                    @input="(val)=>handlePrescriptionInput(val, index)"/>
                  </el-form-item>
                </div>
              </div>
            <div class="row">
              <div class="labelBox">
                <div class="label">处置</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="treat" :show-message="false">
                  <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"  v-model="item.treat"/>
                </el-form-item>
              </div>
              <!--        <div class="label">中成药</div>-->
              <!--        <div class="input-wrapper">-->
              <!--          <el-form-item prop="chinesePatentMedicine" :show-message="false">-->
              <!--            <el-input :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"  v-model="item.chinesePatentMedicine"/>-->
              <!--          </el-form-item>-->
              <!--        </div>-->
            </div>
          </div>
          <div class="aiCard" style="margin-top: 10px">
            <div class="row" style="overflow:hidden;border-radius: 10px 10px 0 0;">
              <div class="labelBox">
                <div class="label2" style="border-left: 1px solid #e0e5ee;">睡眠建议</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="constitution" :show-message="false">
                  <el-input  class="doctorAdviceInput" style="color: #0c85bc;" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.doctorAdvice.sleepAdviceObj.sleepDietaryAdvice"/>
                </el-form-item>
              </div>
              <div class="labelBox">
                <div class="label2" style="border-left: 1px solid #e0e5ee;">睡眠环境建议</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="constitution" :show-message="false">
                  <el-input  class="doctorAdviceInput" style="color: #0c85bc;" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.doctorAdvice.sleepAdviceObj.sleepEnvAdvice"/>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <div class="labelBox">
                <div class="label2">运动建议</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="constitution" :show-message="false">
                  <el-input  class="doctorAdviceInput" style="color: #0c85bc;" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.doctorAdvice.exerciseAdviceObj.pmExerciseAdvice"/>
                </el-form-item>
              </div>
              <div class="labelBox">
                <div class="label2" style="border-left: 1px solid #e0e5ee;">茶饮建议</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="constitution" :show-message="false">
                  <el-input  class="doctorAdviceInput" style="color: #0c85bc;" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.doctorAdvice.teaAdviceObj.teaAdvice"/>
                </el-form-item>
              </div>
            </div>
            <div class="row">
              <div class="labelBox">
                <div class="label2">改善建议</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="constitution" :show-message="false">
                  <el-input  class="doctorAdviceInput" style="color: #0c85bc;" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.doctorAdvice.improveAdviceObj.improveAdvice1"/>
                </el-form-item>
              </div>
              <div class="labelBox">
                <div class="label2"  style="border-left: 1px solid #e0e5ee;">饮食建议</div>
              </div>
              <div class="input-wrapper">
                <el-form-item prop="dialecticalGovernance" :show-message="false">
                  <el-input class="doctorAdviceInput" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" v-model="item.doctorAdvice.dietaryAdviceObj.dietaryAdvice"/>
                </el-form-item>
              </div>
            </div>
          </div>
<!--          <div class="yzsx">-->
<!--            <div class="leftLabelBox">医嘱事项</div>-->
<!--            <div class="inputBox">-->
<!--              <el-input  @focus="yzFocus = true" @blur="yzFocus = false"  :autosize="{ minRows: 1, maxRows: 10 }" type="textarea"  v-model="item.doctorAdvice"/>-->
<!--              <div class="popBox" @mousedown.prevent v-if="yzFocus">-->
<!--                <div class="item" @click.stop="setYzTipValue(tipItem, index)" v-for="(tipItem, tipIndex) in zysxTipList" :key="tipIndex">{{tipItem}}</div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </el-form>
      <!-- 上传方式选择弹框 -->
      <el-dialog
          title="选择上传方式"
          :visible.sync="showUploadDialog"
          width="400px"
          center
          :close-on-click-modal="false"
          :modal="false"
          @click.stop>
        <div class="uploadOptions">
          <div class="uploadOption" @click.stop="selectUploadType('computer')">
            <i class="el-icon-monitor"></i>
            <span>电脑上传</span>
          </div>
          <div class="uploadOption" @click.stop="selectUploadType('phone')">
            <i class="el-icon-mobile-phone"></i>
            <span>手机上传</span>
          </div>
        </div>
        <div class="uploadTip">病历附件支持图片、PDF格式</div>
      </el-dialog>
      <el-dialog
          title="请使用手机扫描二维码上传"
          :visible.sync="QRcodeBoxDialog"
          width="400px"
          center
          @close="closeQRcodeBoxDialog"
          :close-on-click-modal="false"
          :modal="false">
        <!--      {{qrCodeUrl}}-->
        <div  style="display: flex;flex-direction: column;align-items: center;gap: 10px" v-if="mobileUploadStatus === 1">
          <div class="QRcodeBox" id="qrcode" style="display: flex; justify-content: center; align-items: center; min-height: 200px;" ></div>
          <div class="uploadTip">微信扫一扫上传图片</div>
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;gap: 10px" v-if="mobileUploadStatus === 2">
          <img src="data:image/png;base64,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" width="172" height="172">
          <div class="uploadTip">请在手机选择图片并上传</div>
        </div>
        <div style="display: flex;flex-direction: column;align-items: center;gap: 10px" v-if="mobileUploadStatus === 3">
          <el-result icon="success" title="上传成功！" subTitle="">
          </el-result>
        </div>

      </el-dialog>

      <!-- 隐藏的文件输入框 -->
      <input
          ref="fileInput"
          type="file"
          accept="image/*,.pdf"
          multiple
          style="display: none"
          @change="handleFileSelect" />
    </div>
  </div>


  <div class="yfContent" @click.stop>
    <div class="yfHead">
      <div class="title">处方医嘱</div>
      <div class="yfTypeBtn" v-if="!((patient.visitState !== '00' && patient.visitState !== '01') && !isEdit)" @click.stop="addYf()">中药处方</div>
    </div>
    <div class="noData" v-if="!herbalPrescriptionInfo || herbalPrescriptionInfo.length === 0">暂无处方信息</div>
    <div class="yfBox" style="display: flex;flex-direction: column;gap: 20px;">
      <div class="noneMarsk" v-if="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit"></div>
      <div style="background-color: #fff;border-radius: 6px;" v-for="(item, index) in herbalPrescriptionInfo" :key="item.herbalPrescriptionInfoDraftId">
        <div class="option">
          <div class="nameBox">
            <img class="icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAA81BMVEUAAAD79Oz68e368ur68er58ur58ur68ur68ur58ur68en68un58er68+r/+PD68er68+r68er58em/iFD3sWnw4NDXtI/Jmmn47+Xo0r3Ai1T37ePw4tPt28jUr4jRqH/Lnm/EkFz06Nvx5NXky7HixqvgxKfcvJzPpXnwrGbkpGHGlGHy5djmz7f4063NoXTXmVvCjVfEi1Lr2MTq1sLjxajat5L4xZH3voTVrIHPo3f3tW/3sGjzr2fqqGPMkVbFj1b36t346Nb44Mf52rrkyKz4zaP4y53hvZf3yJbcuZXas4vasIf4u37Xq37SonHFkFnObM9HAAAAEnRSTlMARDj87ufZw7+tpZmDbSLzkPJOv6aZAAAB2ElEQVQ4y51V13aCQBDFjoKNsSAqgr3F3mOM6b38/9dEyrKLLHLCfdl2z5w7ZWeYcwT5BBtNZ6Nsgg8yFxHgIgKBCBdwpQZjggMxuvlUXKAinqIoCAsuCDu0JEOCK0JJOzcjXETGZlfwQJLQG/IihyzdKRffqoVaIY+8RDFxiVkbNFyhCJq5oHNLMJiLJVWqm2cjOzEqt65KmoQmtFEude/ohmsGqwoddKP5yFG5Lejqawea6Io7kSM0bmWqDvVVGohWDbq5p5hRGBsrcpGncTsgm2JqxC3PJGjZgEFZW4dTtU5cJxjWyS0XYWFGpEnes0zU2ucRZOiWNHRgrB0tQpRJo20DXNBAjDSTxUKVggF5XDTQPR0UqCJGFsuogCxQIEMFy2AttySFJD2M1puvzXpUlMrYQRy6HVZ3/3KdM9CDHRE6niiHlbG5e8tZmMASJ4VItziY6vXwqFtFhn9FnG6ykJqgnPQ95zBubuEJNzN7iRagWx/Zud/4lbMXv1gDtb9H1H1/Bj8ifg2cf6u2BLNJ/9DrHfqTGcAr2SKdH7bycQQTx88G+RKktQJxsVxtt++t+VkzxU3GE+HUf9qXv8bo3XL9N3PvMeF/AHmPNv9DkxzHaeo4/gPUT3lLu1Rs9AAAAABJRU5ErkJggg==" alt="">
            <div class="name">{{item.prescriptionName}}</div>
          </div>
          <div class="delete" @click.stop="deletYf(item.herbalPrescriptionInfoDraftId)">
            <i class="el-icon-delete"></i>
          </div>
        </div>
        <div class="xfListBox">

          <div class="itemsBox" v-for="(items,indexs) in item.herbalDetails">
            <el-form :model="items" :rules="herbalPrescriptionInfoDetailRules" ref="yfDetailRuleForm">
              <div style="display: flex;align-items: center">
                <el-form-item style="width: 160px" prop="herbalName" :show-message="false">
                  <el-input :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" class="ym" @blur="inputYm(item,index)" placeholder="药名" v-model="items.herbalName" type="text"/>
                </el-form-item>
                <el-form-item style="width: 80px" prop="dosage" :show-message="false">
                  <el-input :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" class="yl" placeholder="用量" v-model="items.dosage" type="text"/>
                </el-form-item>
              </div>
            </el-form>

          </div>
        </div>
        <div class="footerOption">
          <el-form :model="item" :rules="herbalPrescriptionInfoRules" ref="yfRuleForm"  class="demo-ruleForm" :validate-on-rule-change="false">
            <div class="optionRow">
              <el-form-item style="width: 80px" prop="payNumber" :show-message="false">
                <el-input :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" v-model="item.payNumber"></el-input>
              </el-form-item>
              <div class="label">剂</div>
              <el-form-item style="width: 80px" prop="usageMode" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable efault-first-option allow-create filterable v-model="item.usageMode" placeholder="用法">
                  <el-option
                      v-for="option in ZYYF"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.usageMode !=='ZG' && item.usageMode !=='ZW' && item.usageMode !=='DF'" style="width: 120px" prop="dailyDosage" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable efault-first-option allow-create filterable v-model="item.dailyDosage" placeholder="剂量">
                  <el-option
                      v-for="option in JL"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item  style="width: 120px" prop="frequency" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable efault-first-option  allow-create filterable v-model="item.frequency" placeholder="频率">
                  <el-option
                      v-for="option in ZYPL"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.usageMode !=='ZG' && item.usageMode !=='ZW' && item.usageMode !=='DF'" style="width: 120px" prop="dosage" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable default-first-option allow-create filterable v-model="item.dosage" placeholder="服用量">
                  <el-option
                      v-for="option in ZYCGFYL"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.usageMode ==='DF'" style="width: 120px" prop="dosage" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable default-first-option allow-create filterable v-model="item.dosage" placeholder="服用量">
                  <el-option
                      v-for="option in ZYDFFYL"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.usageMode ==='ZW'" style="width: 120px" prop="dosage" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable default-first-option allow-create filterable v-model="item.dosage" placeholder="服用量">
                  <el-option
                      v-for="option in ZYZWFYL"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.usageMode ==='ZG'" style="width: 120px" prop="dosage" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable default-first-option allow-create filterable v-model="item.dosage" placeholder="服用量">
                  <el-option
                      v-for="option in ZYZGFYL"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.usageMode ==='ZG' || item.usageMode ==='ZW' || item.usageMode ==='DF'" style="width: 120px" prop="usageDays" :show-message="false">
                <el-select :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" clearable default-first-option allow-create filterable v-model="item.usageDays" placeholder="服用天数">
                  <el-option
                      v-for="option in ZYFYTS"
                      :key="option.code"
                      :label="option.name"
                      :value="option.code">
                    <span style="float: left">{{ option.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 200px;text-align: left" prop="remark" :show-message="false">
                <el-input  placeholder="备注" :disabled="(patient.visitState !== '00' && patient.visitState !== '01') && !isEdit" v-model="item.remark"></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="j"></div>
        </div>
      </div>
    </div>
    <div class="AIyfTip" v-if="herbalPrescriptionInfo.length !==0">
      <i style="line-height: 40px;margin-top: 1px;margin-right: 2px" class="el-icon-warning-outline"></i>本回答由AI生成，内容仅供参考，具体药物的用法用量需中医师调整配伍
    </div>
  </div>
  <div class="submitBox" v-if="0">
    <div class="btn" @click.stop="submit()" v-if="(expertReview == null || !expertReview) && isShowSubmit">{{expertReview}}专家审核</div>
  </div>
</div>
</template>

<script>
// window.addEventListener('beforeunload', function (e) {

//     // 显示自定义提示信息


//     var customMessage = '您有未保存的更改，确定要离开吗？';


//     alert(customMessage);


//     // 阻止默认行为


//     e.preventDefault();


//     e.returnValue = '';


// });
import img01 from '@/assets/img/img_01.webp'
import selectPop from "@/views/outpatientDoctorWorkstation/outpatientService/components/outpatientServiceContent/components/medicalRecord/components/selectPop";
import {
  zsSelectList,
  xbsSelectList,
  jwsSelectList,
  jzsSelectList,
  gmsSelectList,
  grsSelectList,
  cssSelectList,
  tgjcSelectList,
  kqjcSelectList,
  wwqzSelectList,
  hrSelectList, //以下为新增
  hcSelectList,
  mzSelectList,
  emotionSelectList,
  ysSelectList,
  xbSelectList,
  dbSelectList,
  jqSelectList,
  tzSelectList,
  sgSelectList,
  tizhengSelectList,
  tiwenSelectList,
  maiboSelectList,
  huxiSelectList,
  xueyangSelectList,
  xuetangSelectList,
  mianzhenSelectList,
  shezhenSelectList,
  maizhenSelectList, xueyaSelectList, jwySelectList
} from "@/views/outpatientDoctorWorkstation/outpatientService/staticData";
import {post,get} from "@/api/api";
import QRCode from 'qrcode';
export default {
  name: "index",
  computed: {
    isShowSubmit () {
      return this.$hasPermission(['/outpatientDoctor/expertReview/applyNoMedicalId', '/outpatientDoctor/expertReview/apply']);
    },
    isShowSubmitPreDiagnosis () {
      return this.$hasPermission('/outpatientDoctor/medicalRecord/submitPreDiagnosis');
    },
    xueyaSelectList() {
      return xueyaSelectList
    }
  },
  props:['userInfoData'],
  components:{
    selectPop
  },
  data() {
    return {
      lastReadme: '', // 记录上一次的主诉值
      initialMainSymptoms: '', // 记录初始主症内容
      img01,
      throttleFindOneFlag: false,
      throttleFindOneTimer: null,
      mxxzFocus:false,
      mxxzSelectList: [],
      yzFocus:false,
      zysxTipList:[
          '多喝水，保持身体充足水分',
          '饮食规律宜清淡，忌烟酒，忌辛辣荤腥少',
          '忌吃油炸、腌制、生冷、麻辣等刺激性食物',
          '服头孢前3天和后7天禁止饮酒，忌用外用酒精',
          '保持室内清洁，空气流通',
          '注意休息减少劳累，避免剧烈运动'
      ],
      userInfo:JSON.parse(sessionStorage.getItem('User')),
      formRules:1,
      medicalRecordInfoRules:{
        readme: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        present: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        sleepChronicles: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        emotion: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        diagnosis:[
          {required: false, message: '不能为空',trigger:'submit'},
        ],
        mainSymptoms:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        diet:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        urinate:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        stool:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        period:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        takenMedications:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        weight:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        height:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        tongueDiagnosis:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        pulseDiagnosis:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        allergy:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        personalHistory:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        familyHistory:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
      },
      medicalRecordInfoRules2:{
        readme: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        present: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        sleepChronicles: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        emotion: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        familyHistory:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        allergy:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        personalHistory:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        diagnosis:[
          {required: false, message: '不能为空',trigger:'submit'},
        ],
        mainSymptoms:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        diet:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        urinate:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        stool:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        period:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        takenMedications:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        weight:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        height:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        tongueDiagnosis:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        pulseDiagnosis:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
      },
      herbalPrescriptionInfoRules: {
        payNumber: [
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        usageMode:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        dailyDosage:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        frequency:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
        dosage:[
          {required: true, message: '不能为空',trigger:'submit'},
        ],
      },
      herbalPrescriptionInfoDetailRules: {
        herbalName: [
          {required: true, message: '不能为空',trigger:'blur'},
        ],
        dosage:[
          {required: true, message: '不能为空',trigger:'blur'},
        ]
      },
      QRcodeBoxDialog: false,
      qrCodeUrl: '', // 二维码链接
      fileList: [],
      isAgeYearOk: true,
      isAgeMounthOk: true,
      isAgeDaysOk: true,
      isReadmeOk: true,
      isDiagnosis: true,
      isOkReadme: true,
      isOkDiagnosis: true,
      isOkObservationDiagnosis: true,
      zsFocus: false,
      xbsFocus: false,
      jwsFocus: false,
      jzsFocus: false,
      gmsFocus: false,
      grsFocus: false,
      cssFocus: false,
      tgjcFocus: false,
      kqjcFocus: false,
      wwqzFocus: false,
      hrFocus:false,
      ysFocus:false,
      hcFocus:false,
      xbFocus:false,
      dbFocus:false,
      jqFocus:false,
      tzFocus:false,
      sgFocus:false,
      tiwenFocus:false,
      maiboFocus:false,
      huxiFocus:false,
      xueyaFocus:false,
      xueyangFocus:false,
      xuetangFocus:false,
      shezhenFocus:false,
      maizhenFocus:false,
      mzFocus: false,
      emotionFocus:false,
      isEdit:false,
      herbalPrescriptionInfo:[],
      attachmentIds: [], // 附件ID列表
      medicalRecordInfo: {},
      aiResultList:[],
      // 每个 AI 结果项的文本域 autosize 配置（按索引）
      diagnosisAutosizeList: [],
      dialecticAutosizeList: [],
      therapyAutosizeList: [],
      prescriptionAutosizeList: [],
      // 医疗记录单项的 autosize 配置（按字段）
      dietAutosize: { minRows: 1, maxRows: 10 },
      sleepAutosize: { minRows: 1, maxRows: 10 },
      urinateAutosize: { minRows: 1, maxRows: 10 },
      stoolAutosize: { minRows: 1, maxRows: 10 },
      emotionAutosize: { minRows: 1, maxRows: 10 },
      periodAutosize: { minRows: 1, maxRows: 10 },
      sweatingAutosize: { minRows: 1, maxRows: 10 },
      coldAndHeatAutosize: { minRows: 1, maxRows: 10 },
      takenMedicationsAutosize: { minRows: 1, maxRows: 10 },
      historyAutosize: { minRows: 1, maxRows: 10 },
      familyHistoryAutosize: { minRows: 1, maxRows: 10 },
      allergyAutosize: { minRows: 1, maxRows: 10 },
      personalHistoryAutosize: { minRows: 1, maxRows: 10 },
      tongueDiagnosisAutosize: { minRows: 1, maxRows: 10 },
      pulseDiagnosisAutosize: { minRows: 1, maxRows: 10 },
      birthHistoryAutosize: { minRows: 1, maxRows: 10 },
      epidemicsAutosize: { minRows: 1, maxRows: 10 },
      physiqueAutosize: { minRows: 1, maxRows: 10 },
      auxiliaryExaminationAutosize: { minRows: 1, maxRows: 10 },
      patient: {},
      registerInfo: {},// 挂号信息
      countinueGet: null,
      mobileUploadStatus: 1, //手机上传附件状态
      showDatePicker: false,
      zsSelectList,
      xbsSelectList,
      jwsSelectList,
      jzsSelectList,
      gmsSelectList,
      grsSelectList,
      cssSelectList,
      tgjcSelectList,
      kqjcSelectList,
      wwqzSelectList,
      hrSelectList, //以下为新增
      hcSelectList,
      mzSelectList,
      emotionSelectList,
      ysSelectList,
      xbSelectList,
      dbSelectList,
      jqSelectList,
      tzSelectList,
      sgSelectList,
      tizhengSelectList,
      tiwenSelectList,
      maiboSelectList,
      huxiSelectList,
      xueyangSelectList,
      xuetangSelectList,
      mianzhenSelectList,
      shezhenSelectList,
      maizhenSelectList,
      jwySelectList,
      JL:[], //剂量
      ZYYF:[], //服用方式
      ZYPL:[], //服用频率
      ZYCGFYL:[], // 服用量（煎服，冲服，外用，贴敷）
      ZYDFFYL:[], // 服用量（打粉）
      ZYZWFYL:[], // 服用量（制丸）
      ZYZGFYL:[], // 服用量 （制膏）
      qrCodeId: '',
      ZYFYTS:[], //服用天数
      visitState: null,
      expertReview: null,
      showUploadDialog: false, // 控制上传方式选择弹框显示
      justFinishedReception: false, // 添加标志位，避免重复调用findOne
      isSetZsPatient: false
    }
  },
  watch:{
    '$store.state.isChangeLeftListBar':{
      handler (newValue,oldValue) {
        if (newValue){
         this.$store.state.isChangeLeftListBar = false
          if (this.herbalPrescriptionInfo.length >=2) {
            this.$alert('只能保留1个中药处方，请删除多余的处方后再提交！', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                // this.$message({
                //   type: 'info',
                //   message: '只能保留1个中药处方，请删除多余的处方后再提交！'
                // })
              }
            });
            this.$store.state.stopChange = true
            return
          }
          this.$store.state.stopChange = false
         this.submitPreDiagnosis()
        }
      }
    },
    '$store.state.nowPatientInfo':{
      handler (newValue,oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(oldValue)){
         return
        }
        
        // if (newValue && JSON.stringify(newValue) === JSON.stringify(this.patient)) {
        //   return
        // }
        this.fileList = []
        this.attachmentIds = []
        if (newValue.visitState === '00') {
          this.aiResultList = []
          this.expertReview = null
          this.patient = newValue
          if (this.$refs['medicalRecordInfo']){
            this.$refs['medicalRecordInfo'].clearValidate()
          }
          let data = this.$store.getters.getNowMedicalRecordDraftByDraftId(newValue)

          this.medicalRecordInfo = data.medicalRecordInfo
          this.herbalPrescriptionInfo = data.herbalPrescriptionInfo
          this.attachmentIds = data.attachmentIds
          this.aiResultList = data.aiResultList
          this.registerInfo = data.registerInfo
          if (this.attachmentIds && this.attachmentIds.length!==0){
            this.attachmentIds.forEach(item=>{
              this.getFileBase64Data(item)
            })
          }

          
          if (this.$refs.yfRuleForm && this.$refs.yfRuleForm.length > 0) {
            this.$refs.yfRuleForm.forEach(item=>{
              item.clearValidate()
            })
          }
          if (this.$refs.yfDetailRuleForm && this.$refs.yfDetailRuleForm.length > 0) {
            this.$refs.yfDetailRuleForm.forEach(item=>{
              item.clearValidate()
            })
          }

          this.$nextTick(() => {
            this.initMedicalAutosizeGroups();
            this.forceResizeAll();
          });

        } else if (newValue.medicalRecordId && !this.justFinishedReception){
          // 只有在不是刚刚完成接诊的情况下才调用findOne
          this.findOne(newValue)
        } else if (this.justFinishedReception) {
          // 如果是刚刚完成接诊，重置标志位
          
          this.justFinishedReception = false
        }
      },
      deep:true,
      immediate:true
    },
    medicalRecordInfo:{
      handler (newValue,oldValue) {
        if (this.patient.draftId) {
          this.$store.commit('updateMedicalRecordDraft',{
            draftId:this.patient.draftId,
            medicalRecordInfo: this.medicalRecordInfo,
            herbalPrescriptionInfo:this.herbalPrescriptionInfo,
            attachmentIds:this.attachmentIds,
            aiResultList:this.aiResultList,
            registerInfo: this.registerInfo
          })
        }
      },
      deep:true
    },
    herbalPrescriptionInfo:{
      handler (newValue,oldValue) {
        
        if (this.patient.draftId) {
          this.$store.commit('updateMedicalRecordDraft',{
            draftId:this.patient.draftId,
            medicalRecordInfo: this.medicalRecordInfo,
            herbalPrescriptionInfo:this.herbalPrescriptionInfo,
            attachmentIds:this.attachmentIds,
            aiResultList:this.aiResultList,
            registerInfo: this.registerInfo
          })
        }
      },
      deep:true
    },
    attachmentIds:{
      handler (newValue,oldValue) {
        
        if (this.patient.draftId) {
          this.$store.commit('updateMedicalRecordDraft',{
            draftId:this.patient.draftId,
            medicalRecordInfo: this.medicalRecordInfo,
            herbalPrescriptionInfo:this.herbalPrescriptionInfo,
            attachmentIds:this.attachmentIds,
            aiResultList:this.aiResultList,
            registerInfo: this.registerInfo
          })
        }
      }
    },
    aiResultList:{
      handler (newValue,oldValue) {
        if (this.patient.draftId) {
          this.$store.commit('updateMedicalRecordDraft',{
            draftId:this.patient.draftId,
            medicalRecordInfo: this.medicalRecordInfo,
            herbalPrescriptionInfo:this.herbalPrescriptionInfo,
            attachmentIds:this.attachmentIds,
            aiResultList:this.aiResultList,
            registerInfo: this.registerInfo
          })
        }
        this.$nextTick(() => {
          this.initAutosizeLists();
          this.forceResizeAll();
        });
      },
      deep:true
    }
  },
  mounted() {
    this.getMetadataList()
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.$nextTick(() => {
      this.initAutosizeLists();
      this.initMedicalAutosizeGroups();
      this.forceResizeAll();
    });
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    // 规范化 doctorAdvice 对象结构，确保嵌套属性完整
    normalizeDoctorAdvice(advice) {
      // 先解析 JSON 字符串（如果存在）
      const parsed = this.parseDoctorAdvice(advice);
      
      // 默认结构
      const defaultStructure = {
        dietaryAdviceObj: { dietaryAdvice: '' },
        sleepAdviceObj: { sleepDietaryAdvice: '', sleepEnvAdvice: '' },
        exerciseAdviceObj: { pmExerciseAdvice: '' },
        teaAdviceObj: { teaAdvice: '' },
        improveAdviceObj: { improveAdvice1: '' }
      };
      
      // 如果为空，返回默认结构
      if (!parsed) {
        return JSON.parse(JSON.stringify(defaultStructure));
      }
      
      // 如果已经是对象，确保嵌套结构完整
      if (typeof parsed === 'object') {
        return {
          dietaryAdviceObj: {
            dietaryAdvice: '',
            ...(parsed.dietaryAdviceObj || {})
          },
          sleepAdviceObj: {
            sleepDietaryAdvice: '',
            sleepEnvAdvice: '',
            ...(parsed.sleepAdviceObj || {})
          },
          exerciseAdviceObj: {
            pmExerciseAdvice: '',
            ...(parsed.exerciseAdviceObj || {})
          },
          teaAdviceObj: {
            teaAdvice: '',
            ...(parsed.teaAdviceObj || {})
          },
          improveAdviceObj: {
            improveAdvice1: '',
            ...(parsed.improveAdviceObj || {})
          },
          ...parsed
        };
      }
      
      // 兜底返回默认结构
      return JSON.parse(JSON.stringify(defaultStructure));
    },
    // 解析 doctorAdvice JSON 字符串
    parseDoctorAdvice(advice) {
      if (!advice) {
        return null;
      }
      
      // 如果已经是对象，直接返回
      if (typeof advice === 'object') {
        return advice;
      }
      
      // 如果是字符串，尝试解析 JSON
      if (typeof advice === 'string') {
        try {
          return JSON.parse(advice);
        } catch (e) {
          console.error('解析 doctorAdvice JSON 失败:', e);
          return null;
        }
      }
      
      return null;
    },
     handleBeforeUnload(event) {
       console.log('进来了')
       if (this.isShowSubmitPreDiagnosis) {
         this.$store.state.patientInfoFormRuleType === 1
         if (this.$store.state.aiDiagnosisList.length > 0) {
           // event.preventDefault(); // 阻止默认关闭行为
           // event.returnValue = '当前病历将提交到预诊'; // 触发浏览器默认确认框 [1,6](@ref)
           this.$store.state.activeFirst = true
           this.isSetZsPatient = true
           return  this.submitPreDiagnosis(); // 提交预诊
         }
       }
  },
    addMxxz(val) {
      // 定义各个序列的值
      const sequences = {
        1: ['左', '右'],
        2: ['寸','关','尺'],
        3: ['浮', '沉', '迟', '数', '虚', '实'],
        4: ['濡', '弱', '缓', '促', '细', '弦'],
        5: ['洪', '伏', '涩', '动', '微', '滑'],
        6: ['芤', '牢', '结', '疾', '代', '紧'],
        7: ['革','散','短','长'],
      }

      // 获取值所属的序列
      const getSequence = (value) => {
        for (let seq = 1; seq <= 7; seq++) {
          if (sequences[seq].includes(value)) {
            return seq;
          }
        }
        return 0;
      };

      // 检查是否是互斥值（左或右）
      if (val === '左' || val === '右') {
        const targetVal = val === '左' ? '右' : '左';
        // 查找目标值的位置
        const targetIndex = this.mxxzSelectList.indexOf(targetVal);

        // 如果目标值存在，直接在原位置替换
        if (targetIndex !== -1) {
          this.mxxzSelectList.splice(targetIndex, 1, val);
          return;
        }
      }

      // 检查值是否已存在
      const index = this.mxxzSelectList.indexOf(val);
      if (index !== -1) {
        // 如果值已存在，删除它
        this.mxxzSelectList.splice(index, 1);
      } else {
        // 获取新值的序列
        const newValueSeq = getSequence(val);

        // 找到应该插入的位置
        let insertIndex = 0;
        for (let i = 0; i < this.mxxzSelectList.length; i++) {
          const currentValueSeq = getSequence(this.mxxzSelectList[i]);
          if (currentValueSeq > newValueSeq) {
            break;
          }
          insertIndex = i + 1;
        }

        // 在正确的位置插入新值
        this.mxxzSelectList.splice(insertIndex, 0, val);
      }
    },
    pushMxxz (no) {
      
      if (this.mxxzSelectList.length!==0 && !no){
        const stringResult = this.mxxzSelectList.join('');
        if (this.medicalRecordInfo.pulseDiagnosis) {
          this.medicalRecordInfo.pulseDiagnosis += ','+stringResult
        } else {
          this.medicalRecordInfo.pulseDiagnosis = stringResult
        }

      }
      this.mxxzSelectList = []
      this.mxxzFocus = false

    },
    setYzTipValue(item, index) {
      // 确保aiResultList[index]存在
      if (!this.aiResultList[index]) {
        console.warn('aiResultList索引不存在:', index);
        return;
      }

      // 如果当前医嘱内容为空，直接赋值
      if (!this.aiResultList[index].doctorAdvice) {
        this.aiResultList[index].doctorAdvice = item;
        return;
      }

      // 分割现有医嘱内容为数组（按逗号分隔）
      const adviceList = this.aiResultList[index].doctorAdvice.split(/[,，]/).map(s => s.trim());

      // 检查是否已存在相同的医嘱项
      if (!adviceList.includes(item)) {
        // 不存在则追加
        this.aiResultList[index].doctorAdvice += `，${item}`;
      }
      // 如果已存在，则不做任何操作
    },
    // —— 文本域高度联动（病症/辨证） ——
    clamp(n, min, max) {
      if (n < min) return min;
      if (n > max) return max;
      return n;
    },
    countLines(text) {
      if (!text) return 1;
      // 仅按换行符统计行数，避免复杂的自动换行计算
      return text.split('\n').length;
    },
    initAutosizeLists() {
      const len = Array.isArray(this.aiResultList) ? this.aiResultList.length : 0;
      // 基础最小行统一为 1；最大行统一为 10
      const base = { minRows: 1, maxRows: 10 };
      this.diagnosisAutosizeList = new Array(len).fill(null).map(() => ({ ...base }));
      this.dialecticAutosizeList = new Array(len).fill(null).map(() => ({ ...base }));
      this.therapyAutosizeList = new Array(len).fill(null).map(() => ({ ...base }));
      this.prescriptionAutosizeList = new Array(len).fill(null).map(() => ({ ...base }));
      for (let i = 0; i < len; i++) {
        this.updateAutosizeForGroup(i, ['diagnosis','dialectic']);
        this.updateAutosizeForGroup(i, ['therapy','prescriptionMedicine']);
      }
    },
    // —— 医疗记录单项的联动初始化 ——
    initMedicalAutosizeGroups() {
      const base = { minRows: 1, maxRows: 10 };
      // 重置基础配置
      this.dietAutosize = { ...base };
      this.sleepAutosize = { ...base };
      this.urinateAutosize = { ...base };
      this.stoolAutosize = { ...base };
      this.emotionAutosize = { ...base };
      this.periodAutosize = { ...base };
      this.sweatingAutosize = { ...base };
      this.coldAndHeatAutosize = { ...base };
      this.takenMedicationsAutosize = { ...base };
      this.historyAutosize = { ...base };
      this.familyHistoryAutosize = { ...base };
      this.allergyAutosize = { ...base };
      this.personalHistoryAutosize = { ...base };
      this.tongueDiagnosisAutosize = { ...base };
      this.pulseDiagnosisAutosize = { ...base };
      this.birthHistoryAutosize = { ...base };
      this.epidemicsAutosize = { ...base };
      this.physiqueAutosize = { ...base };
      this.auxiliaryExaminationAutosize = { ...base };

      // 按组更新联动最小行数
      this.updateAutosizeForMedicalGroup(['diet','sleepChronicles']);
      this.updateAutosizeForMedicalGroup(['urinate','stool']);
      this.updateAutosizeForMedicalGroup(['emotion','period']);
      this.updateAutosizeForMedicalGroup(['sweating','coldAndHeat']);
      this.updateAutosizeForMedicalGroup(['takenMedications','history']);
      this.updateAutosizeForMedicalGroup(['familyHistory','allergy','personalHistory']);
      this.updateAutosizeForMedicalGroup(['tongueDiagnosis','pulseDiagnosis']);
      this.updateAutosizeForMedicalGroup(['birthHistory','epidemics']);
      this.updateAutosizeForMedicalGroup(['physique','auxiliaryExamination']);
    },
    // —— 医疗记录单项的联动更新（多字段组） ——
    updateAutosizeForMedicalGroup(keys) {
      // 计算每个键的行数
      const lineCounts = keys.map(k => this.countLines(this.medicalRecordInfo[k]));
      const maxOtherLines = (selfIdx) => {
        const others = lineCounts.filter((_, i) => i !== selfIdx);
        // 如果组内只有一个字段，默认最小行为 1
        return others.length ? Math.max(...others) : 1;
      };
      keys.forEach((key, i) => {
        const minR = this.clamp(Math.max(1, maxOtherLines(i)), 1, 10);
        const config = { minRows: minR, maxRows: 10 };
        switch (key) {
          case 'diet': this.dietAutosize = config; break;
          case 'sleepChronicles': this.sleepAutosize = config; break;
          case 'urinate': this.urinateAutosize = config; break;
          case 'stool': this.stoolAutosize = config; break;
          case 'emotion': this.emotionAutosize = config; break;
          case 'period': this.periodAutosize = config; break;
          case 'sweating': this.sweatingAutosize = config; break;
          case 'coldAndHeat': this.coldAndHeatAutosize = config; break;
          case 'takenMedications': this.takenMedicationsAutosize = config; break;
          case 'history': this.historyAutosize = config; break;
          case 'familyHistory': this.familyHistoryAutosize = config; break;
          case 'allergy': this.allergyAutosize = config; break;
          case 'personalHistory': this.personalHistoryAutosize = config; break;
          case 'tongueDiagnosis': this.tongueDiagnosisAutosize = config; break;
          case 'pulseDiagnosis': this.pulseDiagnosisAutosize = config; break;
          case 'birthHistory': this.birthHistoryAutosize = config; break;
          case 'epidemics': this.epidemicsAutosize = config; break;
          case 'physique': this.physiqueAutosize = config; break;
          case 'auxiliaryExamination': this.auxiliaryExaminationAutosize = config; break;
        }
      });

      // 在联动最小行数更新后，立即触发同组文本域的高度重算（定向 refs）
      this.$nextTick(() => {
        const refMap = {
          diet: 'dietInput',
          sleepChronicles: 'sleepInput',
          urinate: 'urinateInput',
          stool: 'stoolInput',
          emotion: 'emotionInput',
          period: 'periodInput',
          sweating: 'sweatingInput',
          coldAndHeat: 'coldAndHeatInput',
          takenMedications: 'takenMedicationsInput',
          history: 'jwsInput',
          familyHistory: 'familyHistoryInput',
          allergy: 'allergyInput',
          personalHistory: 'personalHistoryInput',
          tongueDiagnosis: 'xuetangInput',
          pulseDiagnosis: 'maizhenInput',
          birthHistory: 'birthHistoryInput',
          epidemics: 'epidemicsInput',
          physique: 'tgjcInput',
          auxiliaryExamination: 'auxiliaryExaminationInput'
        };
        keys.forEach(k => {
          const r = this.$refs[refMap[k]];
          const list = Array.isArray(r) ? r : [r];
          list.forEach(c => {
            if (c && typeof c.resizeTextarea === 'function') {
              c.resizeTextarea();
            }
          });
        });
      });
    },
    updateAutosizeForGroup(index, keys) {
      const item = this.aiResultList[index] || {};
      // 计算每个键的行数
      const lineCounts = keys.map(k => this.countLines(item[k]));
      const maxOtherLines = (selfIdx) => {
        return Math.max(...lineCounts.filter((_, i) => i !== selfIdx));
      };
      // 为组内每个字段设置 minRows= max(1, 其他字段行数)，且不超过 10
      keys.forEach((key, i) => {
        const minR = this.clamp(Math.max(1, maxOtherLines(i)), 1, 10);
        console.log(minR)
        const config = { minRows: minR, maxRows: 10 };
        if (key === 'diagnosis') this.$set(this.diagnosisAutosizeList, index, config);
        else if (key === 'dialectic') this.$set(this.dialecticAutosizeList, index, config);
        else if (key === 'therapy') this.$set(this.therapyAutosizeList, index, config);
        else if (key === 'prescriptionMedicine') this.$set(this.prescriptionAutosizeList, index, config);
      });
    },
    // 强制触发所有文本域的高度计算，避免首屏显示两行的情况
    forceResizeAll() {
      this.$nextTick(() => {
        const callResize = (refArr) => {
          if (!refArr) return;
          const list = Array.isArray(refArr) ? refArr : [refArr];
          list.forEach(c => {
            if (c && typeof c.resizeTextarea === 'function') {
              c.resizeTextarea();
            }
          });
        };
        callResize(this.$refs.diagnosisInput);
        callResize(this.$refs.bzInput);
        callResize(this.$refs.therapyInput);
        callResize(this.$refs.prescriptionInput);
        // 医疗记录单项
        callResize(this.$refs.dietInput);
        callResize(this.$refs.sleepInput);
        callResize(this.$refs.urinateInput);
        callResize(this.$refs.stoolInput);
        callResize(this.$refs.emotionInput);
        callResize(this.$refs.periodInput);
        callResize(this.$refs.sweatingInput);
        callResize(this.$refs.coldAndHeatInput);
        callResize(this.$refs.takenMedicationsInput);
        callResize(this.$refs.jwsInput);
        callResize(this.$refs.familyHistoryInput);
        callResize(this.$refs.allergyInput);
        callResize(this.$refs.personalHistoryInput);
        callResize(this.$refs.xuetangInput);
        callResize(this.$refs.maizhenInput);
        callResize(this.$refs.birthHistoryInput);
        callResize(this.$refs.epidemicsInput);
        callResize(this.$refs.tgjcInput);
        callResize(this.$refs.auxiliaryExaminationInput);
        // 兜底：重复使用的通用 ref
        callResize(this.$refs.xbsInput);
      });
    },
    handleDiagnosisInput(val, index) {
      this.updateAutosizeForGroup(index, ['diagnosis','dialectic']);
    },
    handleDialecticInput(val, index) {
      this.updateAutosizeForGroup(index, ['diagnosis','dialectic']);
    },
    handleTherapyInput(val, index) {
      this.updateAutosizeForGroup(index, ['therapy','prescriptionMedicine']);
    },
    handlePrescriptionInput(val, index) {
      this.updateAutosizeForGroup(index, ['therapy','prescriptionMedicine']);
    },
    deleteFileById (attachmentId) {
      let data = {
        medicalRecordId:this.medicalRecordInfo.id,
        attachmentId:attachmentId
      }
      get('/outpatientDoctor/medicalRecordAttachment/deleteAttachment',data).then(res=>{
        if (res.data.code==200) {
          this.fileList = this.fileList.filter(item => item.id !== attachmentId);
          this.attachmentIds = this.attachmentIds.filter(id => id !== attachmentId);
          this.$message.success('删除成功！')
        }
      })
    },
    closeQRcodeBoxDialog () {
      clearInterval(this.countinueGet)
      this.countinueGet = null
      this.mobileUploadStatus = 1
      this.QRcodeBoxDialog = false
    },
    openFile (val) {
      
      const link = document.createElement('a');
      link.href = val.src;
      link.download = val.fileName // 设置下载文件名
      link.click();
    },
    // 显示备用二维码方案
    showFallbackQR(container) {
      container.innerHTML = `
        <div style="text-align: center;">
          <p>请手动复制链接在手机浏览器中打开：</p>
          <p style="word-break: break-all; font-size: 12px; color: #666; margin: 10px 0;">${this.qrCodeUrl}</p>
          <button onclick="navigator.clipboard.writeText('${this.qrCodeUrl}').then(() => alert('链接已复制到剪贴板'))" style="padding: 8px 16px; background: #1890ff; color: white; border: none; border-radius: 4px; cursor: pointer;">复制链接</button>
        </div>
      `;
    },
    cancelEdit () {
      this.isEdit = false
      this.$parent.isEdit = false
      this.findOne(this.patient,this.medicalRecordInfo)
    },
    getValue (val) {
      // :false,
      //     :false,
      //     :false,
      //     :false,
      //     :false,
      //     :false,
      //     :false,
      //     :false,
      //     :false,
      //     :false,
      //     huxiFocus:false,
      //     xueyaFocus:false,
      //     xueyangFocus:false,
      //     xuetangFocus:false,
      //     shezhenFocus:false,
      //     maizhenFocus:false,
      //     mzFocus: false,
      //     emotionFocus:false,
      //     isEdit:false,
      //     herbalPrescriptionInfo:[],
      //     attachmentIds: [], // 附件ID列表
      //     medicalRecordInfo: {},
      //     aiResultList:[],
      //     patient: {},
      //     registerInfo: {},// 挂号信息
      //     countinueGet: null,
      //     mobileUploadStatus: 1, //手机上传附件状态
      //     showDatePicker: false,
      //     zsSelectList,
      //     xbsSelectList,
      //     jwsSelectList,
      //     jzsSelectList,
      //     gmsSelectList,
      //     grsSelectList,
      //     cssSelectList,
      //     tgjcSelectList,
      //     kqjcSelectList,
      //     wwqzSelectList,
      //     hrSelectList, //以下为新增
      //     hcSelectList,
      //     mzSelectList,
      //     emotionSelectList,
      //     ysSelectList,
      //     xbSelectList,
      //     dbSelectList,
      //     jqSelectList,
      //     tzSelectList,
      //     sgSelectList,
      //     tizhengSelectList,
      //     tiwenSelectList,
      //     maiboSelectList,
      //     huxiSelectList,
      //     xueyangSelectList,
      //     xuetangSelectList,
      //     mianzhenSelectList,
      //     shezhenSelectList,
      //     maizhenSelectList,
      //     jwySelectList,
      //     JL:[], //剂量
      //     ZYYF:[], //服用方式
      //     ZYPL:[], //服用频率
      //     ZYCGFYL:[], // 服用量（煎服，冲服，外用，贴敷）
      //     ZYDFFYL:[], // 服用量（打粉）
      //     ZYZWFYL:[], // 服用量（制丸）
      //     ZYZGFYL:[], // 服用量 （制膏）
      //     qrCodeId: '',
      //     ZYFYTS:[], //服用天数
      //     visitState: null,
      //     expertReview: null,
      //     showUploadDialog: false, // 控制上传方式选择弹框显示
      //     justFinishedReception: false, // 添加标志位，避免重复调用findOne
      //     isSetZsPatient: false
      switch (val.popKey) {
        case 'mzFocus':
          if (this.medicalRecordInfo.sleepChronicles){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.sleepChronicles.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.sleepChronicles += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.sleepChronicles = val.value
          }
          break
        case 'emotionFocus':
          if (this.medicalRecordInfo.emotion){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.emotion.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.emotion += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.emotion = val.value
          }
          break
        case 'hrFocus':
          if (this.medicalRecordInfo.coldAndHeat){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.coldAndHeat.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.coldAndHeat += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.coldAndHeat = val.value
          }
          break
        case 'ysFocus':
          if (this.medicalRecordInfo.diet){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.diet.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.diet += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.diet = val.value
          }
          break
        case 'hcFocus':
          if (this.medicalRecordInfo.sweating){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.sweating.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.sweating += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.sweating = val.value
          }
          break
        case 'xbFocus':
          if (this.medicalRecordInfo.urinate){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.urinate.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.urinate += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.urinate = val.value
          }
          break
        case 'dbFocus':
          if (this.medicalRecordInfo.stool){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.stool.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.stool += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.stool = val.value
          }
          break
        case 'jqFocus':
          if (this.medicalRecordInfo.period){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.period.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.period += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.period = val.value
          }
          break
        case 'tzFocus':
          if (this.medicalRecordInfo.weight){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.weight.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.weight += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.weight = val.value
          }
          break
        case 'sgFocus':
          if (this.medicalRecordInfo.height){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.height.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.height += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.height = val.value
          }
          break
        case 'tiwenFocus':
          if (this.medicalRecordInfo.bodyTemperature){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.bodyTemperature.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.bodyTemperature += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.bodyTemperature = val.value
          }
          break
        case 'maiboFocus':
          if (this.medicalRecordInfo.pulseRate){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.pulseRate.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.pulseRate += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.pulseRate = val.value
          }
          break
        case 'huxiFocus':
          if (this.medicalRecordInfo.breathing){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.breathing.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.breathing += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.breathing = val.value
          }
          break
        case 'xueyaFocus':
          if (this.medicalRecordInfo.bloodPressure){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.bloodPressure.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.bloodPressure += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.bloodPressure = val.value
          }
          break
        case 'xueyangFocus':
          if (this.medicalRecordInfo.bloodOxygen){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.bloodOxygen.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.bloodOxygen += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.bloodOxygen = val.value
          }
          break
        case 'xuetangFocus':
          if (this.medicalRecordInfo.bloodGlucose){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.bloodGlucose.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.bloodGlucose += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.bloodGlucose = val.value
          }
          break
        case 'shezhenFocus':
          if (this.medicalRecordInfo.tongueDiagnosis){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.tongueDiagnosis.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.tongueDiagnosis += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.tongueDiagnosis = val.value
          }
          break
        case 'maizhenFocus':
          if (this.medicalRecordInfo.pulseDiagnosis){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.pulseDiagnosis.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.pulseDiagnosis += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.pulseDiagnosis = val.value
          }
          break

        // -----------------------------------------------------------------
        case 'zsFocus':
          if (this.medicalRecordInfo.readme){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.readme.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.readme += ',' + val.value;
              // 同步到主症
              if (!this.medicalRecordInfo.mainSymptoms) {
                this.medicalRecordInfo.mainSymptoms = val.value;
              } else {
                const lastChar = this.medicalRecordInfo.mainSymptoms.slice(-1);
                if (!/[,，。. ]/.test(lastChar)) {
                  this.medicalRecordInfo.mainSymptoms += '，' + val.value;
                } else {
                  this.medicalRecordInfo.mainSymptoms += val.value;
                }
              }
            }
          } else {
            this.medicalRecordInfo.readme = val.value;
            // 同步到主症
            if (!this.medicalRecordInfo.mainSymptoms) {
              this.medicalRecordInfo.mainSymptoms = val.value;
            } else {
              this.medicalRecordInfo.mainSymptoms += val.value;
            }
          }
          break
        case 'xbsFocus':
          if (this.medicalRecordInfo.present){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.present.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.present += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.present = val.value
          }
          break
        case 'jwsFocus':
          if (this.medicalRecordInfo.history){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.history.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.history += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.history = val.value
          }
          break
        case 'jzsFocus':
          if (this.medicalRecordInfo.familyHistory){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.familyHistory.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.familyHistory += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.familyHistory = val.value
          }
          break
        case 'gmsFocus':
          if (this.medicalRecordInfo.allergy){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.allergy.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.allergy += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.allergy = val.value
          }
          break
        case 'grsFocus':
          if (this.medicalRecordInfo.personalHistory){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.personalHistory.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.personalHistory += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.personalHistory = val.value
          }
          break
        case 'cssFocus':
          if (this.medicalRecordInfo.birthHistory){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.birthHistory.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.birthHistory += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.birthHistory = val.value
          }
          break
        case 'tgjcFocus':
          if (this.medicalRecordInfo.physique){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.physique.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.physique += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.physique = val.value
          }
          break
        case 'kqjcFocus':
          if (this.medicalRecordInfo.oralExamination){
            // 检查是否已存在相同值
            let existingValues = this.medicalRecordInfo.oralExamination.split(',').map(v => v.trim());

            if (['牙龈鲜红', '扪痛（-）', '扪痛（+）'].includes(val.value)) {
              // 如果新值已存在，则不执行任何操作
              if (existingValues.includes(val.value)) {
                return;
              }

              const specialValues = ['牙龈鲜红', '扪痛（-）', '扪痛（+）'];

              // 检查现有值中包含的特殊项
              const existingSpecialValues = existingValues.filter(item => specialValues.includes(item));

              // 如果已存在两个特殊项，删除最后一个
              if (existingSpecialValues.length >= 2) {
                // 找到最后一个特殊项的位置并删除
                for (let i = existingValues.length - 1; i >= 0; i--) {
                  if (specialValues.includes(existingValues[i])) {
                    existingValues.splice(i, 1);
                    break;
                  }
                }
              }

              // 添加新值
              existingValues.push(val.value);

              this.medicalRecordInfo.oralExamination = existingValues.join(',');
            }
            // 普通处理：检查重复
            else if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.oralExamination += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.oralExamination = val.value
          }
          break
        case 'wwqzFocus':
          if (this.medicalRecordInfo.observationDiagnosis){
            // 检查是否已存在相同值
            const existingValues = this.medicalRecordInfo.observationDiagnosis.split(',').map(v => v.trim());
            if (!existingValues.includes(val.value)) {
              this.medicalRecordInfo.observationDiagnosis += ',' + val.value
            }
          } else {
            this.medicalRecordInfo.observationDiagnosis = val.value
          }
          break
      }
      this.$forceUpdate()
    },
    // 处理主诉输入，同步到主症
    handleReadmeInput(value) {
      // 将中文逗号转换为英文逗号
      if (value && value.includes('，')) {
        const cursorPosition = this.$refs.zsInput ? this.$refs.zsInput.$el.querySelector('textarea').selectionStart : 0;
        
        // 替换所有中文逗号为英文逗号
        value = value.replace(/，/g, ',');
        this.medicalRecordInfo.readme = value;
        
        // 恢复光标位置（中英文逗号都是1个字符，长度不变）
        this.$nextTick(() => {
          const textarea = this.$refs.zsInput ? this.$refs.zsInput.$el.querySelector('textarea') : null;
          if (textarea) {
            textarea.setSelectionRange(cursorPosition, cursorPosition);
          }
        });
      }
      
      // 如果主诉为空，清空主症
      if (!value) {
        this.lastReadme = '';
        this.medicalRecordInfo.mainSymptoms = '';
        return;
      }

      // 如果是第一次输入（lastReadme为空），初始化
      if (!this.lastReadme) {
        this.lastReadme = value;
        // 保存初始主症内容
        this.initialMainSymptoms = this.medicalRecordInfo.mainSymptoms || '';
        this.medicalRecordInfo.mainSymptoms = value;
        return;
      }

      // 使用英文逗号分割主诉内容
      const splitByComma = (str) => {
        if (!str) return [];
        return str.split(',').map(item => item.trim()).filter(item => item);
      };

      const oldItems = splitByComma(this.lastReadme);
      const newItems = splitByComma(value);

      // 找出新增的项目和删除的项目
      const addedItems = newItems.filter(item => !oldItems.includes(item));
      const removedItems = oldItems.filter(item => !newItems.includes(item));

      // 获取当前主症内容，如果没有则使用初始内容
      let currentMainSymptoms = this.medicalRecordInfo.mainSymptoms || this.initialMainSymptoms || '';
      let mainSymptomItems = splitByComma(currentMainSymptoms);

      // 判断操作类型（使用英文逗号统计）
      const oldCommaCount = (this.lastReadme.match(/,/g) || []).length;
      const newCommaCount = (value.match(/,/g) || []).length;
      const isItemAdded = newCommaCount > oldCommaCount;   // 新增了完整内容项（通过逗号）
      const isItemDeleted = newCommaCount < oldCommaCount; // 删除了完整内容项
      const isEditingItem = newCommaCount === oldCommaCount && value.length !== this.lastReadme.length; // 编辑现有项

      // 处理新增项目：只要有新增的内容项就追加（不限制必须有逗号）
      if (addedItems.length > 0) {
        addedItems.forEach(item => {
          // 检查主症中是否已存在相同内容（不区分大小写和前后空格）
          const existsInMainSymptoms = mainSymptomItems.some(
            existingItem => existingItem.trim().toLowerCase() === item.trim().toLowerCase()
          );
          
          if (!existsInMainSymptoms) {
            mainSymptomItems.push(item);
          }
        });
      }

      // 处理删除或编辑项目：如果内容有减少，从主症中移除被修改的内容项
      if ((isItemDeleted || isEditingItem) && removedItems.length > 0) {
        // 对于删除或编辑的情况，从主症中移除所有在旧列表中存在但新列表中不存在的项目
        removedItems.forEach(item => {
          // 在主症中查找并移除该项（不区分大小写）
          const index = mainSymptomItems.findIndex(
            existingItem => existingItem.trim().toLowerCase() === item.trim().toLowerCase()
          );
          if (index > -1) {
            mainSymptomItems.splice(index, 1);
          }
        });
        // 注意：主诉不做自动清理，保持用户输入的原始状态
      }

      // 重新组合主症内容（使用英文逗号，与主诉保持一致）
      this.medicalRecordInfo.mainSymptoms = mainSymptomItems.join(',');

      // 更新lastReadme
      this.lastReadme = value;
    },
    //获取字典
    getMetadataList () {
      get('/common/constantItem/getConstantList').then(res=>{
        let data =  res.data.data
        this.JL = data.JL
        this.ZYYF = data.ZYYF //服用方式
        this.ZYCGFYL = data.ZYCGFYL// 服用量（煎服，冲服，外用，贴敷）
        this.ZYDFFYL = data.ZYDFFYL// 服用量（打粉）
        this.ZYZWFYL = data.ZYZWFYL// 服用量（制丸）
        this.ZYZGFYL = data.ZYZGFYL// 服用量 （制膏）
        this.ZYFYTS = data.ZYFYTS//服用天数
        this.ZYPL = data.ZYPL//频率
      })
    },
  // 通过attachmentIds获取fileBase64数据
  getFileBase64Data (fileId) {
    // 检查是否已经存在该文件，避免重复添加
    const existingFile = this.fileList.find(file => file.id === fileId);
    if (existingFile) {
      return;
    }

      get('/outpatientDoctor/medicalRecordAttachment/download',{attachmentId :fileId,medicalRecordId:this.medicalRecordInfo.id}).then(res=>{
        // 再次检查，防止异步请求期间重复添加
        const duplicateCheck = this.fileList.find(file => file.id === res.data.data.id);
        const duplicateCheck2 = this.attachmentIds.find(file => file === res.data.data.id);
        if (!duplicateCheck && duplicateCheck2) {
          this.fileList.push({
            showClose:false,
            id:res.data.data.id,
            fileName: res.data.data.originalName,
            contentType: res.data.data.contentType,
            src:'data:' + res.data.data.contentType+';base64,' + res.data.data.base64,
          })
        }
      })
  },
    findOne (patient,medicalRecordInfo) {
      // 如果节流标志为真，说明300毫秒内已经调用过，直接返回
      if (this.throttleFindOneFlag) {
        return;
      }
      
      // 设置节流标志为真，防止重复调用
      this.throttleFindOneFlag = true;
      
      // 300毫秒后重置节流标志
      clearTimeout(this.throttleFindOneTimer);
      this.throttleFindOneTimer = setTimeout(() => {
        this.throttleFindOneFlag = false;
      }, 300);
      
      let loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      get('/outpatientDoctor/medicalRecord/findOne',{id:patient.medicalRecordId || medicalRecordInfo.id,caseNumber: patient.caseNumber}).then(res=>{
        console.log('findOnefindOnefindOnefindOnefindOnefindOne',res)
        loading.close()
        if (res.data.code === 200) {
          let data = res.data.data
          let patientResp = data.patientResp
          patientResp.visitState = data.registerInfoResp.visitState
          data.patientResp.medicalRecordId = data.medicalRecordInfo.id;
          this.$store.state.nowRegisterInfo = data.registerInfoResp
          this.patient = patientResp
          this.$store.commit('setNowPatientInfo',patientResp)
          this.medicalRecordInfo =data.medicalRecordInfo
          // 保存初始主症内容，用于后续联动逻辑
          this.initialMainSymptoms = data.medicalRecordInfo.mainSymptoms || '';
          this.lastReadme = data.medicalRecordInfo.readme || '';
          this.aiResultList = [
            {
              diagnosis: data.medicalRecordInfo.diagnosis, //病症
              dialectic: data.medicalRecordInfo.dialectic, //辨证
              therapy: data.medicalRecordInfo.therapy, //治法
              prescriptionMedicine: data.medicalRecordInfo.prescriptionMedicine, //方药
              constitution: data.medicalRecordInfo.constitution, //体质
              doctorAdvice: this.normalizeDoctorAdvice(data.medicalRecordInfo.doctorAdvice), //医嘱事项
              dialecticalGovernance: data.medicalRecordInfo.dialecticalGovernance, //辨证要点
              treat: data.medicalRecordInfo.treat, //处置
              chinesePatentMedicine: data.medicalRecordInfo.chinesePatentMedicine,
              prescriptionName: data.herbalPrescriptionInfo.length > 0 ? '中药处方' + this.numberToChinese(data.herbalPrescriptionInfo.length) : null,
            }
          ]
          console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',this.aiResultList)
          this.herbalPrescriptionInfo = data.herbalPrescriptionInfo || []

          this.attachmentIds = data.attachmentIds?data.attachmentIds:[] // 确保attachmentIds不为null
          if (this.attachmentIds.length!==0) {
            this.attachmentIds.forEach(item=>{
              this.getFileBase64Data(item)
            })
          }
          this.registerInfo = data.registerInfoResp
          this.expertReview = data.expertReview
          this.$nextTick(() => {
            this.initMedicalAutosizeGroups();
            this.forceResizeAll();
          });

        } else {
        this.$message.error(res.data.msg)
      }
      }).catch(err => {
        loading.close()
        console.error('获取医疗记录失败:', err);
      });

    },
      // 提交预诊
    submitPreDiagnosis () {
       if (this.aiResultList.length <= 0) {
         return;
       }
      this.$store.state.patientInfoFormRuleType === 1
      this.medicalRecordInfo.diagnosis = this.aiResultList[0] && this.aiResultList[0].diagnosis ? this.aiResultList[0].diagnosis : null;
      this.medicalRecordInfo.dialectic = this.aiResultList[0] && this.aiResultList[0].dialectic ? this.aiResultList[0].dialectic : null;
      this.medicalRecordInfo.therapy = this.aiResultList[0] && this.aiResultList[0].therapy ? this.aiResultList[0].therapy : null;
      this.medicalRecordInfo.prescriptionMedicine = this.aiResultList[0] && this.aiResultList[0].prescriptionMedicine ? this.aiResultList[0].prescriptionMedicine : null;
      this.medicalRecordInfo.constitution = this.aiResultList[0] && this.aiResultList[0].constitution ? this.aiResultList[0].constitution : null;
      this.medicalRecordInfo.doctorAdvice = this.aiResultList[0] && this.aiResultList[0].doctorAdvice ? JSON.stringify(this.aiResultList[0].doctorAdvice) : null;
      this.medicalRecordInfo.dialecticalGovernance =  this.aiResultList[0] && this.aiResultList[0].dialecticalGovernance ? this.aiResultList[0].dialecticalGovernance : null;
      this.medicalRecordInfo.treat = this.aiResultList[0] && this.aiResultList[0].treat ? this.aiResultList[0].treat : null;
      this.medicalRecordInfo.chinesePatentMedicine = this.aiResultList[0] && this.aiResultList[0].chinesePatentMedicine ? this.aiResultList[0].chinesePatentMedicine : null; //中成药
      if (this.$store.state.aiDiagnosisList.length === 0 ) {
        return
      }
       
      // 先清理空的草药明细
      this.cleanEmptyHerbalDetails();
      this.$nextTick(()=>{
        let isOk = true;
        let errorMessage = '';

        // 验证主表单
        this.$refs.medicalRecordInfo.validate(valid => {
        // console.log('主表单验证结果:', valid);
          if (!valid) {
            isOk = false;
            errorMessage = '请完善病历信息';
          }
        });

        // 验证nameGenderAgePhonenumberPiece组件表单
        if (this.$parent.$refs.nameGenderRef && this.$parent.$refs.nameGenderRef.$refs.ruleForm) {
          this.$parent.$refs.nameGenderRef.$refs.ruleForm.validate(valid => {
            // console.log('患者信息表单验证结果:', valid);
            if (!valid) {
              isOk = false;
              errorMessage = '请完善患者信息';
            }
          });
        }

        if (!isOk) {
          // this.$message.warning(errorMessage);
          return Promise.reject(new Error(errorMessage));
        }

        // 所有验证通过，提交数据
        let data = {
          patient: this.patient,
          medicalRecordInfo: this.medicalRecordInfo,
          attachmentIds: this.attachmentIds,
          herbalPrescriptionInfo: this.herbalPrescriptionInfo,
          registerInfo: this.registerInfo,
          aiDiagnosisResultUuids: this.$store.state.aiDiagnosisList.length > 0 ? JSON.parse(JSON.stringify(this.$store.state.aiDiagnosisList)) : null // 添加AI诊断结果
        };
        if (data.patient.gender === "NAN") {
          data.medicalRecordInfo.period = ""
        }
        if(data.patient.caseNumber) {
          data.registerInfo.caseNumber = data.patient.caseNumber
        }
        // 如果是草稿状态，设置就诊日期为当前日期
        if(data.patient.visitState === '00'){
          data.patient.visitDate = this.$getCurrentDate()
          data.registerInfo.visitDate = this.$getCurrentDate()
        }
        let loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let url = '/outpatientDoctor/medicalRecord/submitPreDiagnosis'
        // 如果是草稿状态，完成确诊后删除草稿
          return post(url,data).then(res=>{
            loading.close();
            let data = res.data.data
            this.$store.state.aiDiagnosisList = []
            if (this.patient.visitState == '00') {
              this.deletDraft(this.patient.draftId)
            }
            this.$store.state.resetList = 2
            data.patientResp.medicalRecordId = data.medicalRecordInfo.id
            data.patientResp.visitState = data.registerInfoResp.visitState

            if (this.isSetZsPatient) {
              this.$store.state.zcPatient = data.patientResp
            }
            // 设置标志位，避免重复调用findOne
            this.justFinishedReception = true;
            // 更新当前选中的患者信息为接诊后的患者信息
            // 这会触发父组件中的watch监听器，进而更新UI
            // data.patientResp.medicalRecordId  = data.medicalRecordInfo.id
            // this.$store.commit('setNowPatientInfo', data.patientResp)
            // this.$store.commit('updateResetLeftList', true)
            return res;
          },err=>{
            loading.close()
          })
        
      })
    },
    // 专家审核
    submit () {
       this.formRules = 1
      this.$store.state.patientInfoFormRuleType === 1
      if (this.herbalPrescriptionInfo.length >=2) {
        this.$alert('只能保留1个中药处方，请删除多余的处方后再提交！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: '只能保留1个中药处方，请删除多余的处方后再提交！'
            // })
          }
        });
        return
      }
      this.medicalRecordInfo.diagnosis = this.aiResultList[0] && this.aiResultList[0].diagnosis ? this.aiResultList[0].diagnosis : null;
      this.medicalRecordInfo.dialectic = this.aiResultList[0] && this.aiResultList[0].dialectic ? this.aiResultList[0].dialectic : null;
      this.medicalRecordInfo.therapy = this.aiResultList[0] && this.aiResultList[0].therapy ? this.aiResultList[0].therapy : null;
      this.medicalRecordInfo.prescriptionMedicine = this.aiResultList[0] && this.aiResultList[0].prescriptionMedicine ? this.aiResultList[0].prescriptionMedicine : null;
      this.medicalRecordInfo.constitution = this.aiResultList[0] && this.aiResultList[0].constitution ? this.aiResultList[0].constitution : null;
      this.medicalRecordInfo.doctorAdvice = this.aiResultList[0] && this.aiResultList[0].doctorAdvice ? JSON.stringify(this.aiResultList[0].doctorAdvice) : null;
      this.medicalRecordInfo.dialecticalGovernance =  this.aiResultList[0] && this.aiResultList[0].dialecticalGovernance ? this.aiResultList[0].dialecticalGovernance : null;
      this.medicalRecordInfo.treat = this.aiResultList[0] && this.aiResultList[0].treat ? this.aiResultList[0].treat : null;
      this.medicalRecordInfo.chinesePatentMedicine = this.aiResultList[0] && this.aiResultList[0].chinesePatentMedicine ? this.aiResultList[0].chinesePatentMedicine : null; //中成药
      // 先清理空的草药明细
      this.cleanEmptyHerbalDetails();
      this.$nextTick(()=>{
        let isOk = true;
        let errorMessage = '';

        // 验证主表单
        this.$refs.medicalRecordInfo.validate(valid => {
          // console.log('主表单验证结果:', valid);
          if (!valid) {
            isOk = false;
            errorMessage = '请完善病历信息';
          }
        });

        // 验证处方表单
        if (this.$refs.yfRuleForm && this.$refs.yfRuleForm.length > 0) {
          this.$refs.yfRuleForm.forEach(item => {
            item.validate(valid => {
              // console.log('处方表单验证结果:', valid);
              // this.$message.warning("请完善中药处方的用法/剂量/频率/服用量")
              if (!valid) {
                isOk = false;
                errorMessage = '请完善中药处方的用法/剂量/频率/服用量';
              }
            });
          });
        }

        // 验证处方明细表单
        if (this.$refs.yfDetailRuleForm && this.$refs.yfDetailRuleForm.length > 0) {
          this.$refs.yfDetailRuleForm.forEach(item => {
            item.validate(valid => {
              // console.log('处方明细表单验证结果:', valid);
              if (!valid) {
                isOk = false;
                errorMessage = '请完善中药处方信息';
              }
            });
          });
        }

        // 验证nameGenderAgePhonenumberPiece组件表单
        if (this.$parent.$refs.nameGenderRef && this.$parent.$refs.nameGenderRef.$refs.ruleForm) {
          this.$parent.$refs.nameGenderRef.$refs.ruleForm.validate(valid => {
            // console.log('患者信息表单验证结果:', valid);
            if (!valid) {
              isOk = false;
              errorMessage = '请完善患者信息';
            }
          });
        }

        if (!isOk) {
          this.$message.warning(errorMessage);
          return Promise.reject(new Error(errorMessage));
        }

        // 所有验证通过，提交数据
        let data = {
          patient: this.patient,
          medicalRecordInfo: this.medicalRecordInfo,
          attachmentIds: this.attachmentIds,
          herbalPrescriptionInfo: this.herbalPrescriptionInfo,
          registerInfo: this.registerInfo,
          aiDiagnosisResultUuids: this.$store.state.aiDiagnosisList.length > 0 ? JSON.parse(JSON.stringify(this.$store.state.aiDiagnosisList)) : null // 添加AI诊断结果
        };
        if (data.patient.gender === "NAN") {
          data.medicalRecordInfo.period = ""
        }
        if(!data.patient.noon) {
         data.patient.noon = this.getNoonValue(); // 获取当前时间的午别
        }
        if(data.patient.caseNumber) {
          data.registerInfo.caseNumber = data.patient.caseNumber
        }
        if(data.patient.visitState === '00'){
          data.patient.visitDate = this.$getCurrentDate()
          data.registerInfo.visitDate = this.$getCurrentDate()
        }
        let loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let url
        if (!this.isEdit && this.patient.visitState === '02') {
          url = '/outpatientDoctor/expertReview/apply'
          return get(url,{medicalId:this.medicalRecordInfo.id}).then(res=>{
            loading.close();
            this.expertReview = {}
            // 设置标志位，避免重复调用findOne
            this.justFinishedReception = true;
            return res;
          }).catch(error=>{
            loading.close();
          })
        } else {
          url = '/outpatientDoctor/expertReview/applyNoMedicalId'
          return post(url,data).then(res=>{
            loading.close();
            let data = res.data.data
            data.patientResp.medicalRecordId = data.medicalRecordInfo.id
            data.patientResp.visitState = data.registerInfoResp.visitState
            this.$store.state.nowPatientInfo = data.patientResp
            this.$store.state.zcPatient = data.patientResp
            this.registerInfo = data.registerInfoResp
            if (this.patient.visitState == '00') {
              this.deletDraft(this.patient.draftId)
            }
              this.$store.state.resetList = 2
            // 设置标志位，避免重复调用findOne
            this.justFinishedReception = true;
            return res;
          },err=>{
            loading.close()
          })
        }
      })
    },
    deletDraft (draftId) {
      this.$store.commit('deleteMedicalRecordDraft',draftId)
      this.$store.commit('deletePatientDraft',draftId)
      
      // 清空当前患者信息，避免状态残留
      this.$store.state.nowPatientInfo = {}
    },
    // ai诊断
    aiDiagnosis () {
      this.medicalRecordInfo.allergy = this.medicalRecordInfo.allergy ? this.medicalRecordInfo.allergy : '无'
      this.medicalRecordInfo.familyHistory = this.medicalRecordInfo.familyHistory ? this.medicalRecordInfo.familyHistory : '无'
        this.medicalRecordInfo.personalHistory = this.medicalRecordInfo.personalHistory ? this.medicalRecordInfo.personalHistory : '无'
      this.medicalRecordInfo.takenMedications = this.medicalRecordInfo.takenMedications ?  this.medicalRecordInfo.takenMedications : '无'
      this.formRules = 2
      this.$nextTick(() => {
        let isOk = true;
        let errorMessage = '';

        // 验证主表单
        this.$refs.medicalRecordInfo.validate(valid => {
          if (!valid) {
            isOk = false;
            errorMessage = '请完善病历信息';
          }
        });

        // 验证nameGenderAgePhonenumberPiece组件表单
        if (this.$parent.$refs.nameGenderRef && this.$parent.$refs.nameGenderRef.$refs.ruleForm) {
          this.$parent.$refs.nameGenderRef.$refs.ruleForm.validate(valid => {
            if (!valid) {
              isOk = false;
              errorMessage = '请完善患者信息';
            }
          });
        }

        if (!isOk) {
          this.$message.warning(errorMessage);
          return Promise.reject(new Error(errorMessage));
        }
        // let data = {
        //   allergies: this.medicalRecordInfo.allergy, //过敏史
        //   birthday: this.patient.birthday, //生日 不能为空
        //   chiefComplaint: this.medicalRecordInfo.readme, //主诉 不能为空
        //   familyHistory: this.medicalRecordInfo.familyHistory, //家族史
        //   gender: this.patient.gender === 'NAN' ? '男' : '女', //性别 不能为空
        //   pastMedicalHistory: this.medicalRecordInfo.history, //既往史
        //   present: this.medicalRecordInfo.present, //现病史
        //   tcmDiagnostic: this.medicalRecordInfo.observationDiagnosis //望闻切诊 //不能为空
        // }
        let data = {
          patient: this.patient,
          medicalRecordInfo: this.medicalRecordInfo,
          attachmentIds: this.attachmentIds,
          herbalPrescriptionInfo: this.herbalPrescriptionInfo,
          registerInfo: this.registerInfo
        }
        if(data.patient.caseNumber) {
          data.registerInfo.caseNumber = data.patient.caseNumber
        }
        let loading = this.$loading({
          lock: true,
          text: '智能诊断中，这可能需要一点时间，请耐心等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        return post('/outpatientDoctor/medicalRecord/aiDiagnosis', data).then(res => {
          loading.close();
          let data = res.data.data;
          if (res) {
            // 判断是否需要弹框：如果两个列表都为空，或者虽然有数据但所有字段都为空，就不弹框
            const shouldShowDialog = () => {
              // 1. 如果两个列表长度都为0，不弹框
              if (this.aiResultList.length === 0 && this.herbalPrescriptionInfo.length === 0) {
                return false;
              }
              
              // 2. 检查aiResultList是否有非空字段
              const hasAiResultData = this.aiResultList.some(item => 
                item.diagnosis || item.dialectic || item.therapy ||
                item.prescriptionMedicine || item.constitution ||
                item.doctorAdvice.dietaryAdviceObj.dietaryAdvice ||
                  item.doctorAdvice.dietaryAdviceObj.dietaryAdvice ||
                  item.doctorAdvice.sleepAdviceObj.sleepDietaryAdvice ||
                  item.doctorAdvice.sleepAdviceObj.sleepEnvAdvice ||
                  item.doctorAdvice.exerciseAdviceObj.pmExerciseAdvice ||
                  item.doctorAdvice.teaAdviceObj.teaAdvice ||
                  item.doctorAdvice.improveAdviceObj.improveAdvice1 ||
                item.dialecticalGovernance || item.treat || item.chinesePatentMedicine
              );
              this.aiResultList.forEach(item=>{


              })
              // 3. 检查herbalPrescriptionInfo是否有非空字段
              const hasHerbalData = this.herbalPrescriptionInfo.some(item => 
                item.herbalDetails?.some(detail => detail.dosage || detail.herbalName)
              );
              
              // 如果有任何一个列表有非空数据，就弹框
              return hasAiResultData || hasHerbalData;
            };
            
            if (shouldShowDialog()) {
              // 先弹出诊断完成弹窗
              this.$msgbox({
                title: '诊断完成',
                message: '是否覆盖现有诊断以及中药处方等病历信息？',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: '覆盖',
                cancelButtonText: '插入',
                distinguishCancelAndClose: true, // 区分"取消"和"关闭"
                showClose: true, // 显示右上角关闭按钮（作为"取消"操作）
                closeOnClickModal: false, // 禁止点击遮罩关闭
                beforeClose: (action, instance, done) => {
                  // 覆盖操作
                  if (action === 'confirm') {
                    this.$store.state.aiDiagnosisList.push(data.uuid);
                    this.aiResultList = [
                      {
                        diagnosis: data.diagnosis, //病症
                        dialectic: data.dialectic, //辨证
                        therapy: data.therapy, //治法
                        prescriptionMedicine: data.tcmFormulas, //方药
                        constitution: data.tcmConstitutions, //体质
                        doctorAdvice: this.normalizeDoctorAdvice(data.doctorAdvice), //医嘱事项
                        dialecticalGovernance: data.syndromeDifferentiatio, //辨证要点
                        treat: data.treat, //处置
                        chinesePatentMedicine: data.chinesePatentMedicine, //中成药
                        prescriptionName: '诊断结果一'
                      }
                    ]
                    let herbalDetails = [];
                    if (data.aiHerbalDetailList.length !== 0) {
                      data.aiHerbalDetailList.forEach(item => {
                        herbalDetails.push({
                          "dosage": item.dosage, // 剂量
                          "herbalName": item.herbalName, // 草药名称
                          "operator": this.userInfo.id // 操作者ID
                        });
                      });
                      herbalDetails.push({
                        "dosage":'', // 剂量
                        "herbalName": '', // 草药名称
                        "operator": this.userInfo.id // 操作者ID
                      });
                    }
                    this.herbalPrescriptionInfo = [];
                    this.herbalPrescriptionInfo.push({
                      herbalPrescriptionInfoDraftId: Date.now().toString(),
                      "creator": this.userInfo.id, // 创建者ID
                      "dailyDosage": "1", // 剂量
                      "dosage": "120", // 服用量
                      "frequency": "YRLC", // 频率
                      "id": 0, // 唯一标识符
                      "medicalID": 0, // 医疗ID
                      "operator": 0, // 操作者ID
                      "payNumber": 1, // 支付编号
                      "prescriptionName": '中药处方' + numberToChinese(this.herbalPrescriptionInfo.length + 1), // 处方名称
                      "registID": 0, // 挂号ID
                      "remark": "", // 备注
                      "state": 0, // 状态
                      "usageDays": "", // 使用天数
                      "usageMode": "JF", // 使用方式
                      "userID": this.userInfo.id, // 用户ID
                      "herbalDetails": herbalDetails // 草药详情
                    });
                    done();
                  } else if (action === 'cancel') {
                    this.$store.state.aiDiagnosisList.push(data.uuid);
                    // 插入操作
                    // 先关闭当前 msgbox 弹窗
                    done();
                    // 异步执行后续弹窗链路，确保 msgbox 已关闭
                    setTimeout(() => {
                      let herbalDetails = [];
                      if (data.aiHerbalDetailList.length !== 0) {
                        data.aiHerbalDetailList.forEach(item => {
                          herbalDetails.push({
                            "dosage": item.dosage, // 剂量
                            "herbalName": item.herbalName, // 草药名称
                            "operator": this.userInfo.id // 操作者ID
                          });
                        });
                        herbalDetails.push({
                          "dosage":'120', // 剂量
                          "herbalName": '', // 草药名称
                          "operator": this.userInfo.id // 操作者ID
                        });
                      }
                      // 先判断是否已存在3个中药处方
                      if (this.herbalPrescriptionInfo.length === 3) {
                        // 先弹出"是否覆盖中药处方一"弹窗，用户确认后再执行覆盖
                        this.$confirm('已存在三个中药处方，是否覆盖中药处方一', '提示', {
                          confirmButtonText: '确认',
                          cancelButtonText: '取消',
                          center: true,
                          type: 'warning'
                        }).then(() => {
                          // 直接替换对象不会触发响应式，需用$set
                          this.$set(this.herbalPrescriptionInfo, 0, {
                            herbalPrescriptionInfoDraftId: Date.now().toString(),
                            "creator": this.userInfo.id, // 创建者ID
                            "dailyDosage": "1", // 剂量
                            "dosage": "120", // 服用量
                            "frequency": "YRLC", // 频率
                            "id": 0, // 唯一标识符
                            "medicalID": 0, // 医疗ID
                            "operator": 0, // 操作者ID
                            "payNumber": 1, // 支付编号
                            "prescriptionName": '中药处方一', // 始终覆盖第一个
                            "registID": 0, // 挂号ID
                            "remark": "", // 备注
                            "state": 0, // 状态
                            "usageDays": "", // 使用天数
                            "usageMode": "JF", // 使用方式
                            "userID": this.userInfo.id, // 用户ID
                            "herbalDetails": herbalDetails // 草药详情
                          });
                          this.$set(this.aiResultList, 0, {
                            diagnosis: data.diagnosis, //病症
                            dialectic: data.dialectic, //辨证
                            therapy: data.therapy, //治法
                            prescriptionMedicine: data.tcmFormulas, //方药
                            constitution: data.tcmConstitutions, //体质
                            doctorAdvice: this.normalizeDoctorAdvice(data.doctorAdvice), //医嘱事项
                            dialecticalGovernance: data.syndromeDifferentiatio, //辨证要点
                            treat: data.treat, //处置
                            chinesePatentMedicine: data.chinesePatentMedicine, //中成药
                            prescriptionName: '诊断结果' + numberToChinese(this.herbalPrescriptionInfo.length),
                          })
                          this.$forceUpdate();
                          
                        }).catch(() => {
                          // 用户取消覆盖，不做处理
                        });
                      } else {
                        this.herbalPrescriptionInfo.push({
                          herbalPrescriptionInfoDraftId: Date.now().toString(),
                          "creator": this.userInfo.id, // 创建者ID
                          "dailyDosage": "1", // 剂量
                          "dosage": "120", // 服用量
                          "frequency": "YRLC", // 频率
                          "id": 0, // 唯一标识符
                          "medicalID": 0, // 医疗ID
                          "operator": 0, // 操作者ID
                          "payNumber": 1, // 支付编号
                          "prescriptionName": '中药处方' + numberToChinese(this.herbalPrescriptionInfo.length+1), // 处方名称
                          "registID": 0, // 挂号ID
                          "remark": "", // 备注
                          "state": 0, // 状态
                          "usageDays": "", // 使用天数
                          "usageMode": "JF", // 使用方式
                          "userID": this.userInfo.id, // 用户ID
                          "herbalDetails": herbalDetails // 草药详情
                        });
                        this.aiResultList.push(
                            {
                              diagnosis: data.diagnosis, //病症
                              dialectic: data.dialectic, //辨证
                              therapy: data.therapy, //治法
                              prescriptionMedicine: data.tcmFormulas, //方药
                              constitution: data.tcmConstitutions, //体质
                              doctorAdvice: this.normalizeDoctorAdvice(data.doctorAdvice), //医嘱事项
                              dialecticalGovernance: data.syndromeDifferentiatio, //辨证要点
                              treat: data.treat, //处置
                              chinesePatentMedicine: data.chinesePatentMedicine, //中成药
                              prescriptionName: '诊断结果' + numberToChinese(this.herbalPrescriptionInfo.length),
                            }
                        )
                      }
                    }, 50); // setTimeout保证第二个弹窗不会被第一个弹窗关闭影响
                  } else if (action === 'close') {
                    done();
                  }
                }
              });
            } else {
              this.$store.state.aiDiagnosisList.push(data.uuid);
              this.aiResultList = [
                {
                  diagnosis: data.diagnosis, //病症
                  dialectic: data.dialectic, //辨证
                  therapy: data.therapy, //治法
                  prescriptionMedicine: data.tcmFormulas, //方药
                  constitution: data.tcmConstitutions, //体质
                  doctorAdvice: this.normalizeDoctorAdvice(data.doctorAdvice), //医嘱事项
                  dialecticalGovernance: data.syndromeDifferentiatio, //辨证要点
                  treat: data.treat, //处置
                  chinesePatentMedicine: data.chinesePatentMedicine, //中成药
                  prescriptionName: '诊断结果一'
                }
              ]
              // this.medicalRecordInfo.diagnosis = data.diagnosis;
              // this.medicalRecordInfo.dialectic = data.dialectic;
              // this.medicalRecordInfo.therapy = data.therapy;
              // this.medicalRecordInfo.prescriptionMedicine = data.tcmFormulas;
              // this.medicalRecordInfo.constitution = data.tcmConstitutions;
              // this.medicalRecordInfo.doctorAdvice = data.doctorAdvice;
              // this.medicalRecordInfo.dialecticalGovernance = data.syndromeDifferentiatio;
              // this.medicalRecordInfo.treat = data.treat //处置
              let herbalDetails = [];
              if (data.aiHerbalDetailList.length !== 0) {
                data.aiHerbalDetailList.forEach(item => {
                  herbalDetails.push({
                    "dosage": item.dosage, // 剂量
                    "herbalName": item.herbalName, // 草药名称
                    "operator": 1 // 操作者ID
                  });
                });
                herbalDetails.push({
                  "dosage":'', // 剂量
                  "herbalName": '', // 草药名称
                  "operator": this.userInfo.id // 操作者ID
                });
              }
              this.herbalPrescriptionInfo = [];
              this.herbalPrescriptionInfo.push({
                "creator": 1, // 创建者ID
                "dailyDosage": "1", // 剂量
                "dosage": "120", // 服用量
                "frequency": "YRLC", // 频率
                "id": 0, // 唯一标识符
                "medicalID": 0, // 医疗ID
                "operator": 0, // 操作者ID
                "payNumber": 1, // 支付编号
                "prescriptionName": '中药处方' + numberToChinese(this.herbalPrescriptionInfo.length+1), // 处方名称
                "registID": 0, // 挂号ID
                "remark": "", // 备注
                "state": 0, // 状态
                "usageDays": "", // 使用天数
                "usageMode": "JF", // 使用方式
                "userID": this.userInfo.id, // 用户ID
                "herbalDetails": herbalDetails// 草药详情
              })
            }
          }
          function numberToChinese(num) {
            const chineseNumbers = [
              '', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
              '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'
            ];

            // 输入验证
            if (!Number.isInteger(num) || num < 1 || num > 20) {
              throw new Error('只支持1-20的整数');
            }

            return chineseNumbers[num];
          }
          return res;
        }).catch(err=>{
          loading.close()
          // 使用通用错误处理工具
          this.$errorHandler.showError(err, {
            defaultMessage: '智能诊断失败，请稍后重试',
            onAuthError: () => {
              // 认证错误时的额外处理（可选）
              console.log('认证错误，将自动跳转登录页')
            }
          })
        })
      })
    },
        //获取午别
    getNoonValue() {
      const currentHour = new Date().getHours();
      if (currentHour >= 0 && currentHour < 12) {
        return '01'; // 上午（0:00-11:59）
      } else if (currentHour >= 12 && currentHour < 18) {
        return '03'; // 下午（12:00-17:59）
      } else {
        return '05'; // 晚上（18:00-23:59）
      }
    },
    save () {
      this.formRules = 1
      this.$store.state.patientInfoFormRuleType === 1
      if (this.herbalPrescriptionInfo.length >=2) {
        this.$alert('只能保留1个中药处方，请删除多余的处方后再提交！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: '只能保留1个中药处方，请删除多余的处方后再提交！'
            // })
          }
        });
        return
      }
      this.medicalRecordInfo.diagnosis = this.aiResultList[0] && this.aiResultList[0].diagnosis ? this.aiResultList[0].diagnosis : null;
      this.medicalRecordInfo.dialectic = this.aiResultList[0] && this.aiResultList[0].dialectic ? this.aiResultList[0].dialectic : null;
      this.medicalRecordInfo.therapy = this.aiResultList[0] && this.aiResultList[0].therapy ? this.aiResultList[0].therapy : null;
      this.medicalRecordInfo.prescriptionMedicine = this.aiResultList[0] && this.aiResultList[0].prescriptionMedicine ? this.aiResultList[0].prescriptionMedicine : null;
      this.medicalRecordInfo.constitution = this.aiResultList[0] && this.aiResultList[0].constitution ? this.aiResultList[0].constitution : null;
      this.medicalRecordInfo.doctorAdvice = this.aiResultList[0] && this.aiResultList[0].doctorAdvice ? JSON.stringify(this.aiResultList[0].doctorAdvice) : null;
      this.medicalRecordInfo.dialecticalGovernance =  this.aiResultList[0] && this.aiResultList[0].dialecticalGovernance ? this.aiResultList[0].dialecticalGovernance : null;
      this.medicalRecordInfo.treat = this.aiResultList[0] && this.aiResultList[0].treat ? this.aiResultList[0].treat : null;
      this.medicalRecordInfo.chinesePatentMedicine = this.aiResultList[0] && this.aiResultList[0].chinesePatentMedicine ? this.aiResultList[0].chinesePatentMedicine : null; //中成药
      // 先清理空的草药明细
      this.cleanEmptyHerbalDetails();
      this.$nextTick(()=>{
        let isOk = true;
        let errorMessage = '';

        // 验证主表单
        this.$refs.medicalRecordInfo.validate(valid => {
          console.log('主表单验证结果:', valid);
          if (!valid) {
            isOk = false;
            errorMessage = '请完善病历信息';
          }
        });

        // 验证处方表单
        if (this.$refs.yfRuleForm && this.$refs.yfRuleForm.length > 0) {
          this.$refs.yfRuleForm.forEach(item => {
            item.validate(valid => {
              // console.log('处方表单验证结果:', valid);
              if (!valid) {
                isOk = false;
                errorMessage = '请完善处方信息';
              }
            });
          });
        }

        // 验证处方明细表单
        if (this.$refs.yfDetailRuleForm && this.$refs.yfDetailRuleForm.length > 0) {
          this.$refs.yfDetailRuleForm.forEach(item => {
            item.validate(valid => {
              // console.log('处方明细表单验证结果:', valid);
              if (!valid) {
                isOk = false;
                errorMessage = '请完善处方明细信息';
              }
            });
          });
        }

        // 验证nameGenderAgePhonenumberPiece组件表单
        if (this.$parent.$refs.nameGenderRef && this.$parent.$refs.nameGenderRef.$refs.ruleForm) {
          this.$parent.$refs.nameGenderRef.$refs.ruleForm.validate(valid => {
            // console.log('患者信息表单验证结果:', valid);
            if (!valid) {
              isOk = false;
              errorMessage = '请完善患者信息';
            }
          });
        }

        if (!isOk) {
          this.$message.warning(errorMessage);
          return Promise.reject(new Error(errorMessage));
        }

        // 所有验证通过，提交数据
        let data = {
          patient: this.patient,
          medicalRecordInfo: this.medicalRecordInfo,
          attachmentIds: this.attachmentIds,
          herbalPrescriptionInfo: this.herbalPrescriptionInfo,
          registerInfo: this.registerInfo,
          aiDiagnosisResultUuids: this.$store.state.aiDiagnosisList.length > 0 ? JSON.parse(JSON.stringify(this.$store.state.aiDiagnosisList)) : null // 添加AI诊断结果
        };
        if (data.patient.gender === "NAN") {
          data.medicalRecordInfo.period = ""
        }
        if(data.patient.caseNumber) {
          data.registerInfo.caseNumber = data.patient.caseNumber
        }
        let loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        return post('/outpatientDoctor/medicalRecord/save',data).then(res=>{
          loading.close()
          if (res.data.code === 200) {
            this.isEdit = false
            this.$parent.isEdit = false
            this.fileList = []
            this.$message.success('保存成功！')
          }
          return res;
        },err=>{
          loading.close()
        })
      })

    },


    finishReception() {
       this.$store.state.patientInfoFormRuleType === 1
      if (this.herbalPrescriptionInfo.length >=2) {
           this.$alert('只能保留1个中药处方，请删除多余的处方后再提交！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            // this.$message({
            //   type: 'info',
            //   message: '只能保留1个中药处方，请删除多余的处方后再提交！'
            // })
          }
        });
        return
      }
      this.medicalRecordInfo.diagnosis = this.aiResultList[0] && this.aiResultList[0].diagnosis ? this.aiResultList[0].diagnosis : null;
      this.medicalRecordInfo.dialectic = this.aiResultList[0] && this.aiResultList[0].dialectic ? this.aiResultList[0].dialectic : null;
      this.medicalRecordInfo.therapy = this.aiResultList[0] && this.aiResultList[0].therapy ? this.aiResultList[0].therapy : null;
      this.medicalRecordInfo.prescriptionMedicine = this.aiResultList[0] && this.aiResultList[0].prescriptionMedicine ? this.aiResultList[0].prescriptionMedicine : null;
      this.medicalRecordInfo.constitution = this.aiResultList[0] && this.aiResultList[0].constitution ? this.aiResultList[0].constitution : null;
      this.medicalRecordInfo.doctorAdvice = this.aiResultList[0] && this.aiResultList[0].doctorAdvice ? JSON.stringify(this.aiResultList[0].doctorAdvice) : null;
      this.medicalRecordInfo.dialecticalGovernance =  this.aiResultList[0] && this.aiResultList[0].dialecticalGovernance ? this.aiResultList[0].dialecticalGovernance : null;
      this.medicalRecordInfo.treat = this.aiResultList[0] && this.aiResultList[0].treat ? this.aiResultList[0].treat : null;
      this.medicalRecordInfo.chinesePatentMedicine = this.aiResultList[0] && this.aiResultList[0].chinesePatentMedicine ? this.aiResultList[0].chinesePatentMedicine : null; //中成药
      this.cleanEmptyHerbalDetails();
      this.$nextTick(()=>{
        let isOk = true;
        let errorMessage = '';

        // 验证主表单
        this.$refs.medicalRecordInfo.validate(valid => {
          // console.log('主表单验证结果:', valid);
          if (!valid) {
            isOk = false;
            errorMessage = '请完善病历信息';
          }
        });

        // 验证处方表单
        if (this.$refs.yfRuleForm && this.$refs.yfRuleForm.length > 0) {
          this.$refs.yfRuleForm.forEach(item => {
            item.validate(valid => {
              console.log('处方表单验证结果:', valid);
              if (!valid) {
                isOk = false;
                errorMessage = '请完善处方信息';
              }
            });
          });
        }

        // 验证处方明细表单
        if (this.$refs.yfDetailRuleForm && this.$refs.yfDetailRuleForm.length > 0) {
          this.$refs.yfDetailRuleForm.forEach(item => {
            item.validate(valid => {
              console.log('处方明细表单验证结果:', valid);
              if (!valid) {
                isOk = false;
                errorMessage = '请完善处方明细信息';
              }
            });
          });
        }

        // 验证nameGenderAgePhonenumberPiece组件表单
        if (this.$parent.$refs.nameGenderRef && this.$parent.$refs.nameGenderRef.$refs.ruleForm) {
          this.$parent.$refs.nameGenderRef.$refs.ruleForm.validate(valid => {
            // console.log('患者信息表单验证结果:', valid);
            if (!valid) {
              isOk = false;
              errorMessage = '请完善患者信息';
            }
          });
        }

        if (!isOk) {
          this.$message.warning(errorMessage);
          return Promise.reject(new Error(errorMessage));
        }

        // 所有验证通过，提交数据
        let data = {
          patient: this.patient,
          medicalRecordInfo: this.medicalRecordInfo,
          attachmentIds: this.attachmentIds,
          herbalPrescriptionInfo: this.herbalPrescriptionInfo,
          registerInfo: this.registerInfo,
          aiDiagnosisResultUuids: this.$store.state.aiDiagnosisList.length > 0 ? JSON.parse(JSON.stringify(this.$store.state.aiDiagnosisList)) : null // 添加AI诊断结果
        };
        if (data.patient.gender === "NAN") {
          data.medicalRecordInfo.period = ""
        }
        if(data.patient.caseNumber) {
          data.registerInfo.caseNumber = data.patient.caseNumber
        }
        if(!data.patient.noon) {
         data.patient.noon = this.getNoonValue(); // 获取当前时间的午别
        }
        if(data.patient.visitState === '00'){
          data.patient.visitDate = this.$getCurrentDate()
          data.registerInfo.visitDate = this.$getCurrentDate()
        }
        let loading = this.$loading({
          lock: true,
          text: '提交中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        return post('/outpatientDoctor/medicalRecord/finishReception', data).then(res => {
          console.log(res)
          loading.close();
          if (res.data.code === 200) {
            let data = res.data.data
            data.patientResp.medicalRecordId = data.medicalRecordInfo.id
            data.patientResp.visitState = data.registerInfoResp.visitState
            if (this.patient.visitState == '00') {
              this.deletDraft(this.patient.draftId)
            }
            this.$store.state.resetList = 2
            data.patientResp.visitState = '02'
            this.$store.state.nowPatientInfo = data.patientResp
            this.$store.state.zcPatient = data.patientResp
            this.isEdit = false
            this.patient = data.patientResp
            this.medicalRecordInfo = data.medicalRecordInfo
            this.herbalPrescriptionInfo = data.herbalPrescriptionInfo
            this.registerInfo = data.registerInfoResp
            // 设置标志位，避免重复调用findOne
            this.justFinishedReception = true;
            return res;
          } else {
            this.$message.error(res.data.msg || '接诊失败')
          }

        }, err => {
          loading.close();
          return Promise.reject(err);
        });
      })
    },
    // 删除中药方herbalDetails中所有herbalName和dosage都为空的项
    cleanEmptyHerbalDetails() {
      this.herbalPrescriptionInfo.forEach((item, index) => {
        if (item.herbalDetails?.length > 1) {
          // 过滤掉完全空的项
          item.herbalDetails = item.herbalDetails.filter(d =>
              d.herbalName || d.dosage
          );

          // 如果过滤后没有任何项，移除整个处方
          if (item.herbalDetails.length === 0) {
            this.herbalPrescriptionInfo.splice(index, 1);
          }
        }
      });
    },
    closeSelectPop (v) {
      this[v] = false
    },
    // 生成二维码
    generateQRCode() {
      // 生成唯一的二维码ID
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 1000000);
      this.qrCodeId = `QR_${timestamp}_${random}`;

      // 构建H5页面URL，包含患者和病历信息
      const baseUrl = window.location.origin;
      const h5Url = `${baseUrl}/mobile-upload.html`;

      // 准备传递给H5页面的数据，只传递必要参数减少二维码密度
      const patientData = {
        name: this.patient.name || '匿名患者',
        gender: this.patient.gender || '男',
        userId: this.userInfo.id
      }
      if (this.medicalRecordInfo.id) {
        patientData.medicalRecordId = this.medicalRecordInfo.id
      }
      // 构建完整的URL，只传递patient和attachmentIds
      const params = new URLSearchParams({
        qrCodeId:encodeURIComponent(JSON.stringify(this.qrCodeId)),
        patient: encodeURIComponent(JSON.stringify(patientData)),
        attachmentIds: encodeURIComponent(JSON.stringify(this.attachmentIds))
      });

      this.qrCodeUrl = `${h5Url}?${params.toString()}`;

      // 使用QRCode库生成二维码
       this.$nextTick(async () => {
         const qrContainer = document.getElementById('qrcode');
         if (qrContainer) {
           qrContainer.innerHTML = ''; // 清空之前的内容

           try {
             // 创建canvas元素
             const canvas = document.createElement('canvas');
             qrContainer.appendChild(canvas);

             // 使用导入的QRCode库生成二维码
             await QRCode.toCanvas(canvas, this.qrCodeUrl, {
               width: 280,
               height: 280,
               margin: 4,
               errorCorrectionLevel: 'L',
               color: {
                 dark: '#000000',
                 light: '#ffffff'
               }
             });
             console.log('二维码生成成功');
             this.sendGenerateQRCode()
           } catch (error) {
             console.error('二维码生成失败:', error);
             this.showFallbackQR(qrContainer);
           }
         }
       });
    },
    // 发送手机上传附件二维码
    sendGenerateQRCode () {
      post(`/outpatientDoctor/medicalRecordAttachment/generateQRCode?qrCode=${this.qrCodeId}`).then(res=>{
        console.log('发送生成手机上传二维码通知成功！', res)
        if (res.data.code === 200) {
          this.countinueGet = setInterval(()=>{
            this.getPhoneUploadStatus()
          },1000)

        }
      })
    },
    // 获取手机上传附件的状态
    getPhoneUploadStatus () {
      get('/outpatientDoctor/medicalRecordAttachment/getPhoneUploadStatus',{qrCode: this.qrCodeId}).then(res=>{
        console.log('状态状态：', res)
        if (res.data.data && res.data.data.status === "UPLOAD_SUCCESS") {
          clearInterval(this.countinueGet)
          this.countinueGet = null
          this.mobileUploadStatus = 3
          let mobileAttachmentIds = res.data.data.attachmentIds
          if (mobileAttachmentIds && mobileAttachmentIds.length!==0) {
           mobileAttachmentIds.forEach(item=>{
             this.attachmentIds.push(item)
              this.getFileBase64Data(item)
            })
          }
          setTimeout(()=>{
            this.closeQRcodeBoxDialog()
          },2000)
        } else if (res.data.data && res.data.data.status === "GENERATED_QRCODE") {
          this.mobileUploadStatus = 1
        } else if (res.data.data && res.data.data.status === "SCANED_QRCODE") {
          this.mobileUploadStatus = 2
        }

      })
    },
    // 选择上传类型
    selectUploadType(type) {
      this.showUploadDialog = false;
      if (type === 'computer') {
        // 触发文件选择
        console.log('电脑选择附件')
        this.$refs.fileInput.click();
      } else if (type === 'phone') {
        this.QRcodeBoxDialog = true;
        this.$nextTick(() => {
          this.generateQRCode();
        });
      }
    },
    // 处理文件选择
    handleFileSelect(event) {
      const files = Array.from(event.target.files);
      console.log('fffff', files)
      files.forEach(file => {
        // 检查文件类型
        const isValidType = file.type.startsWith('image/') || file.type === 'application/pdf';
        if (!isValidType) {
          this.$message({
            message: `文件 ${file.name} 格式不支持，请上传图片或PDF文件`,
            type: 'warning'
          });
          return;
        }

        // 检查文件大小（限制为10MB）
        const isValidSize = file.size / 1024 / 1024 < 10;
        if (!isValidSize) {
          this.$message({
            message: `文件 ${file.name} 大小超过10MB，请选择较小的文件`,
            type: 'warning'
          });
          return;
        }

        // 添加到上传列表
        const fileInfo = {
          name: file.name,
          size: file.size,
          type: file.type === 'application/pdf' ? 'pdf' : 'image',
          file: file,
          id: Date.now() + Math.random() // 临时ID
        };
        console.log('fifififi', fileInfo)
        // 这里可以添加实际的文件上传逻辑
        this.uploadFile(fileInfo);
      });

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    // 上传文件到服务器
    uploadFile(fileInfo) {
      console.log('ufuffuuf', fileInfo)
      // 创建FormData对象
      const formData = new FormData();
      formData.append('files', fileInfo.file);
      formData.append('uploadUserId', this.userInfo.id);
      console.log('medicalRecordInfoIdmedicalRecordInfoID', this.medicalRecordInfo.id)
      if (this.medicalRecordInfo.id) {
        formData.append('medicalId', this.medicalRecordInfo.id);
      }
      // 调试FormData内容
      console.log('FormData内容:');
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      // 发送请求，确保Content-Type为multipart/form-data
      post('/outpatientDoctor/medicalRecordAttachment/upload/batch', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res=>{
        console.log('上传成功:', res)
        this.fileList.push({
          showClose: false,
          id:res.data.data[0].id,
          fileName: res.data.data[0].originalName,
          contentType: res.data.data[0].contentType,
          src:'data:' + res.data.data[0].contentType+';base64,' + res.data.data[0].base64,
        })
        this.attachmentIds.push(res.data.data[0].id)
        // 处理上传成功后的逻辑
        if (res.code === 200) {
          this.$message.success('文件上传成功');
          // 可以在这里更新文件列表或其他UI状态
        }
      }).catch(err => {
        console.error('上传失败:', err)
        this.$message.error('文件上传失败');
      })
    },
    // 移除文件
    removeFile(index) {

    },
    addYf () {
      if (this.herbalPrescriptionInfo.length >= 3) {
        this.$message.warning('最多只能添加3个中药处方');
        return;
      }
      
      this.aiResultList.push({
        diagnosis: '', //病症
        dialectic: '', //辨证
        therapy: '', //治法
        prescriptionMedicine: '', //方药
        constitution: '', //体质
        doctorAdvice: this.normalizeDoctorAdvice(''), //医嘱事项
        dialecticalGovernance:'', //辨证要点
        treat: '', //处置
        prescriptionName: '诊断结果' + this.numberToChinese(this.herbalPrescriptionInfo.length + 1),
      })
      
      this.herbalPrescriptionInfo.push({
        herbalPrescriptionInfoDraftId:Date.now().toString(), //药方草稿id
        creator:this.userInfo.id,
        userID: this.userInfo.id,
        dailyDosage: "1", //剂量
        dosage: "120", //服用量
        frequency: "YRLC", //频率
        herbalDetails: [ // 草药详情
          {
            operator:this.userInfo.id,
            herbalDetailsDraftId:Date.now().toString(), //草药服用详情id
            herbalName:null, //草药名称
            dosage: null, //用量
          }
        ],
        operator:this.userInfo.id, //操作者id
        payNumber: 1, //剂
        prescriptionName:'中药处方' + this.numberToChinese(this.herbalPrescriptionInfo.length+1), // 处方名称
        remark:null, //备注
        usageDays: null,//使用天数
        usageMode:'JF', //使用方式
      })
    },
    numberToChinese(num) {
      console.log('cccccccccccc',num)
      const chineseNumbers = [
        '', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
        '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'
      ];

      // 输入验证
      if (!Number.isInteger(num) || num < 1 || num > 20) {
        throw new Error('只支持1-20的整数');
      }

      return chineseNumbers[num];
    },
    deletYf (herbalPrescriptionInfoDraftId) {
      // 删除逻辑
      const index = this.herbalPrescriptionInfo.findIndex(
          item => item.herbalPrescriptionInfoDraftId === herbalPrescriptionInfoDraftId
      );
      if (index !== -1) this.herbalPrescriptionInfo.splice(index, 1);
      if (index !== -1) this.aiResultList.splice(index, 1);
      // 响应式更新名称
      this.$nextTick(()=>{
        this.herbalPrescriptionInfo.forEach((item, idx) => {
          this.$set(item, 'prescriptionName', '中药处方' + this.numberToChinese(idx + 1));
        });
        this.aiResultList.forEach((item, idx) => {
          this.$set(item, 'prescriptionName', '诊断结果' + this.numberToChinese(idx + 1));
        });
        this.$forceUpdate();
      })

      console.log('中药处方中药处方中药处方中药处方中药处方', this.herbalPrescriptionInfo)
    },
    inputYm(item, index) {
      // 检查是否所有 herbalDetails 都有 herbalName
      const allHaveName = item.herbalDetails.every(detail => detail.herbalName);

      if (allHaveName) {
        this.herbalPrescriptionInfo[index].herbalDetails.push({
          isInput: false,
          herbalDetailsDraftId: Date.now().toString(), // 草药服用详情id
          herbalName: null, // 草药名称
          dosage: null, // 用量
        });
      }
    },
  }
}
</script>

<style lang="less" scoped>
.medicalRecord{
  width: 100%;
  box-sizing: border-box;
  padding-right: 5px;
  .head{
    height: 40px;
    padding: 0 7px 0 12px;
    border-radius: 6px 6px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--primary-color2);
    .title{
      font-size: 14px;
      color: var(--sideMenun-text-color);
      font-weight: 700;
    }
    .addFile{
      background: linear-gradient(135deg, #FFF8DC 0%, #F5DEB3 100%);
      width: 70px;
      height: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid #CD853F;
      color: #8B4513;
      cursor: pointer;
      user-select: none;
      transition: all 0.3s ease;
      &:hover{
        background: linear-gradient(135deg, #F5DEB3 0%, #DEB887 100%);
        color: #654321;
      }
      &:active{
        background: linear-gradient(135deg, #DEB887 0%, #CD853F 100%);
        color: #FFF;
      }
    }
  }
.contentBody{
  display: flex;
  flex-direction: column;
  align-content: center;
  .contentNone{
    flex: 1;
    //width: 100%;
    display: flex;
    flex-direction: column;
    //border: 1px solid red;
    //margin-right: 10px;
    position: relative;
    .noneMarsk{
      height: 110%;
      width: 100%;
      position: absolute;
      z-index: 999;
      //background-color: red;
    }
    /deep/ .el-input__inner{
      height: 36px;
      border-radius: 0;
      background: none;
      //border: none;
      border: 1px solid transparent;
      box-sizing: border-box;
      color: #000;
      &:focus {
        border-color: #0270c9;
        box-shadow: 0 0 0 2px #c3e0fe;
      }
      &:hover {
        border-color: #0270c9;
      }
    }
  }
  .content{
    //width: 100%;
    display: flex;
    flex-direction: column;
    //border: 1px solid red;
    //margin-right: 10px;
    flex: 1;
    //background-color: #fffdec;
    /deep/ .el-input__inner{
      height: 36px;
      border-radius: 0;
      background: none;
      //border: none;
      border: 1px solid transparent;
      box-sizing: border-box;
      color: #000;
      &:focus {
        border-color: #0270c9;
        box-shadow: 0 0 0 2px #c3e0fe;
      }
      &:hover {
        border-color: #0270c9;
      }
    }
  }
}
  .card {
    background-color: #f5f7f9;
    border-radius: 0px 0px 10px 10px;
    //overflow: hidden;
    border-bottom: 1px solid #e0e5ee;
  }
  .parentBox{
    display: flex;
    align-items: stretch;
    width: 100%;
    height: auto;
    border-left: 1px solid #e0e5ee;
    box-sizing: border-box;
    .leftParent{
      flex: 1;
      max-width: 108px;
      min-width: 108px;
      padding-left: 10px;
      line-height: 36px;
      text-align: left;
      color: #626d77;
      border-top: 1px solid #e0e5ee;
      display: flex;
      align-items: center;
      font-weight: 700;
      box-sizing: border-box;
      font-size: 12px;
      font-family: "微软雅黑 Light";
    }
    .rightChildrenBox {
      flex: 1;
      .label{
        height: 50px;
        width: 98px;
        min-width: 98px;
        padding-left: 10px;
        line-height: 36px;
        text-align: left;
        //border-right: 1px solid #e0e5ee;
        color: #626d77;
        font-weight: 500;
      }
    }
  }

  .row{
    width: 100%;
    //min-height: 38.5px;
    border: 1px solid #e0e5ee;
    border-bottom: none;
    box-sizing: border-box;
    display: flex;
    align-items: stretch;
    position: relative;
    .wwqz{
      box-sizing: border-box;
      min-width: 120px;
      color: rgba(0,0,0,0.4);
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      user-select: none;
      position: relative;
      min-height: 40px;
      top: 50%;
      &:hover{
        color: #B22222;
      }
      .mxxzPop{
        padding: 15px;
        position: absolute;
        width: 345px;
        left: -300px;
        top: 40px;
        //border: 1px solid red;
        background-color: #fff;
        border: 1px solid #e0e5ee;
        box-shadow: 0 3px 12px 2px rgba(0, 0, 0, .1);
        overflow: hidden;
        border-radius: 6px;
        z-index: 999;
        display: flex;
        flex-direction: column;
        .contentBox{
         height: 295px;
          //border: 1px solid red;
          display: flex;
          flex-direction: column;
          gap: 10px;
          .row{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 20px;
            border: none;
            .item{
              height: 30px;
              width: 30px;
              border: 1px solid rgba(0,0,0,0.2);
              border-radius: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(0,0,0,0.5);
              cursor: pointer;
              user-select: none;
              box-sizing: border-box;
              &:hover{
                color: rgba(0,0,0,0.3);
                background-color: rgba(0,0,0,0.2);
              }
            }
            .itemed{
              height: 30px;
              width: 30px;
              border: none;
              border-radius: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              background-color: #409eff;
              cursor: pointer;
              user-select: none;
              &:hover{
                color: #fff;
                background-color: rgba(64, 158, 255, 0.61);
              }
            }
          }
        }
        .showBox{
          display: flex;
          align-items: center;
          min-height: 40px;
          border-top: 1px solid rgba(0,0,0,0.1);
          //margin-top: 5px;
          padding-top: 5px;
          .selectValue{
            height: 100%;
            flex: 1;
            color: #000;
            font-size: 13px;
            display: flex;
            flex-wrap: wrap;
            &:hover{
              color: #000;
            }
          }
          .ok{
            height: 30px;
            display: flex;
            align-items: center;
            margin-top: 10px;
          }
        }
      }
    }
    .uploadBox{
      width: 100%;
      height: 100%;
      //border: 1px solid red;
      display: flex;
      align-items: center;
      .fileListItem{
        height: 34px;
        width: 34px;
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 5px;
        //border: 1px solid #ceceec;
        .imgBox{
          height: 100%;
          width: 100%;
          position: relative;
          .close{
            position: absolute;
            top: -5px;
            right: -5px;
            border-radius: 100px;
            background-color: #fff;
            cursor: pointer;
            i{
              font-size: 16px;
              color: #e51616;
            }

          }
          img{
            height: 100%;
            width: 100%;
          }
        }

      }
      .uploadBtn{
        height: 30px;
        width: 30px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px dashed #ceceec;
        margin-left: 2px;
        cursor: pointer;
        user-select: none;
        font-size: 20px;
        &:hover{
          border: 1px solid #ceceec;
        }
      }
    }
    //.label{
    //  position: absolute;
    //  height: 100%;
    //  min-width: 109px;
    //  max-width: 109px;
    //  padding-left: 11px;
    //  line-height: 36px;
    //  text-align: left;
    //  //border-right: 1px solid #e0e5ee;
    //  color: #626d77;
    //  font-weight: 700;
    //  display: flex;
    //  align-items: center;
    // box-sizing: border-box;
    //}
    .labelBox{
      flex: 1;
      min-width: 109px;
      max-width: 109px;
      position: relative;
      z-index: 10;
      .label{
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        padding-left: 11px;
        line-height: 36px;
        text-align: left;
        border-right: 1px solid #e0e5ee;
        color: #626d77;
        font-weight: 700;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        font-size: 12px;
        font-family: "微软雅黑 Light";
      }
      .label2{
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        padding-left: 11px;
        line-height: 36px;
        text-align: left;
        border-right: 1px solid #e0e5ee;
        color: #408198;
        font-weight: 700;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        font-size: 12px;
        font-family: "微软雅黑 Light";

      }
    }
  }
  /deep/.el-input__inner{
    text-align: left;
    height: 40px;
    border-radius: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    //border: 1px solid red;
    box-sizing: border-box;

  }
  .timeSelect{
    //border: 1px solid red;
    height: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
    width: 260px;
    justify-content: center;
    position: relative;
    .dateLabel{
      position: absolute;
      color: #7a8794;
      user-select: none;
      display: flex;
      align-items: center;
      min-height: 40px;
      //top: 50%;
      min-width: fit-content;
      top: 0;
      i{
        margin-left: 5px;
      }
    }
    .pickerBox{
      opacity: 0;
      border: 1px solid red;
      /deep/  .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 100%;
        cursor: pointer;
      }
      /deep/ .el-input--prefix .el-input__inner{
        cursor: pointer;
      }
    }
  }
  /deep/ .el-textarea__inner::placeholder {
    line-height: 2;
    font-size: 12px;
    color: #bfbfbf;
    font-family: '微软雅黑 Light';
    /* 避免长提示文案在空值时换行撑高 */
    //white-space: nowrap;
    //text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    //top: -3px;
  }
  /deep/ .el-form-item__content {
    font-size: 12px;
    line-height: 2;
  }
  /deep/ .el-textarea__inner {
    width: 100%;
    border-radius: 0;
    border-color: transparent;
    resize: none !important;
    background-color: rgba(0,0,0,0);
    overflow: hidden;
    box-sizing: border-box;
    font-weight: 700;
    font-family: "微软雅黑 Light";
    //font-size: 1px;
    color: #000;
    //border-left: 1px solid #e0e5ee;
    position: relative;
    //height: 40px !important;
    line-height: 2 !important;
    min-height: 0 !important;
    font-size: 12px;
    //transform: scale(0.95);
    transform-origin: 0 0;
    text-align: left;
    &:focus {
      border-color: #0270c9;
      box-shadow: 0 0 0 2px #c3e0fe;
    }
    &:hover {
      border-color: #0270c9;
    }
  }
  /deep/ .el-form-item.is-error .el-textarea__inner {
    border: 1px solid var(--error-color) !important;
    background-color: var(--error-color2) !important;
  }
   .el-form-item.is-error .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus {
    border: 1px solid var(--error-color) !important;
    background-color: var(--error-color2) !important;
  }
  //.popBox{
  //  width: 85.3%;
  //  position: absolute;
  //  z-index: 1;
  //  left: 108px;
  //  top: 40px;
  //}
  .yzsx{
    margin-top: 20px;
    min-height: 36px;
    width: 100%;
    border: 1px solid #e0e5ee;
    border-radius: 10px;
    background-color: #fff;
    //margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    /deep/ .el-textarea__inner{
      width: 100%;
      border-radius: 0;
      //min-height: 40px !important;
      resize: none !important;
      background-color: rgba(0,0,0,0);
      //border: 1px solid red;
      box-sizing: border-box;
      color: #606266 !important;
      font-weight: 600 !important;
      border-left: 1px solid #e0e5ee;
      line-height: 12x !important;
      min-height: 0 !important;
    }
    .leftLabelBox{
      color: #7a8794;
      height: 100%;
      width: 98px;
      //border-right: 1px solid #e0e5ee;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
    }
    .inputBox{
     flex: 1;
      width: 100%;
      border: none;
      position: relative;
      /deep/ .el-input__inner {
        border: none;
        border-radius: 0px 6px 6px 0px;
        color: #606266 !important;
        font-weight: 600 !important;
      }
      .popBox{
        height: auto;
        width: auto;
        min-width: 400px;
        border-radius: 6px;
        background-color: #fff;
        border: 1px solid #e0e5ee;
        box-shadow: 0 3px 12px 2px rgba(0, 0, 0, .1);
        overflow: hidden;
        //position: absolute;
        //left: 0;
        padding: 10px 10px;
        display: flex;
        flex-direction: column;
        font-size: 13px;
        gap: 15px;
        .item{
          height: 40px;
          display: flex;
          align-items: center;
          border-radius: 6px;
          cursor: pointer;
          user-select: none;
          padding: 0 10px;
          font-family: "微软雅黑";
          &:hover{
            background-color: rgba(64,158,255,.2);

          }
        }
      }
    }
  }
  .yfContent{
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    //background-color: #fff;
    //overflow: hidden;
    padding-bottom: 120px;
    .noData {
      width: 100%;
      height: 100px;
      background-color: #fff;
      border-radius: 0 0 6px 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-family: "微软雅黑 Light";
      color: rgba(0,0,0,.4);
    }
    .yfHead{
      height: 40px;
      width: 100%;
      border-bottom: 1px solid #e0e5ee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      background-color: #fff;
      border-radius: 6px 6px 0 0;
      margin-top: 10px;
      .title{
        font-weight: 700;
        color: #000;
        margin-left: 15px;
      }
      .yfTypeBtn{
        padding: 5px 8px;
        border: 1px solid #e0e5ee;
        color: #7a8794;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
        margin-right: 15px;
      }
    }
    .option{
      height: 40px;
      width: 100%;
      border-bottom: 1px solid #e0e5ee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      .nameBox{
        display: flex;
        align-items: center;
        margin-left: 15px;
        .icon{
          height: 24px;
          width: 24px;
        }
        .name{
          font-weight: 700;
          color: #7a8794;
          margin-left: 10px;
        }
      }
      .delete{
        margin-right: 15px;
        cursor: pointer;
        user-select: none;
        i{
          color: #7a8794;
          font-size: 16px;
        }
      }
    }
    .xfListBox{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .itemsBox{
        height: 58px;
        display: flex;
        //border: 1px solid red;
        align-items: center;
        width: calc(100% / 4);
        border-right: 1px dashed #e0e5ee;
        border-top: 1px dashed #e0e5ee;
        border-bottom: 1px dashed #e0e5ee;
        padding: 0 10px;
        box-sizing: border-box;
        .ym{
          //border: none;
        }
        .yl{
          border: none;
          width: 100px;
          text-align: center !important;
        }
        .unit{}
        /deep/ .el-input__inner{
          height: 36px;
          border-radius: 0;
          background: none;
          //border: none;
          //border: 1px solid transparent;
          //box-sizing: border-box;
          color: #606266 !important;
          font-weight: 600 !important;
          &:focus {
            border-color: #0270c9;
            box-shadow: 0 0 0 2px #c3e0fe;
          }
          &:hover {
            border-color: #0270c9;
          }
        }
      }
    }
    .footerOption{
      height: 41px;
      background-color: #fff;
      border-top: 1px dashed #e0e5ee;
      display: flex;
      align-items: center;
      .optionRow{
        height: 41px;
        display: flex;
        align-items: center;
      }
    }
  }
  .aiResultGroup {
    margin-top: 20px;
    overflow: hidden;

    .aiCard{
      background-color: #fff;
      border-radius: 10px;
      overflow: hidden;
      border-bottom: 1px solid #e0e5ee;
    }
    .title{
      height: 40px;
      line-height: 40px;
      font-size:14px;
      font-weight: 700;
      padding-left: 10px;
      color: var(--error-color);
      display: flex;
      align-items: center;

      span{
        .icon{
          height: 24px;
          width: 24px;
          position: relative;
          top: 6px;
          margin-right: 5px;
        }

        color: #7a8794;
      }
    }
  }
  .submitBox {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -100px;
    margin-left: -25px;
    .btn {
      width: 260px;
      height: 46px; /* 稍微增加高度 */
      border-radius: 6px; /* 更大的圆角 */
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff; /* 米色文字 */
      cursor: pointer;
      user-select: none;
      font-weight: 500; /* 中等粗细字体 */
      font-size: 16px; /* 标准字体大小 */
      background: var(--primary-color); /* 中医风格渐变背景 */
      transition: all 0.3s ease; /* 平滑过渡效果 */

      &:hover {
        background:  var(--header-color); /* 反转渐变 */
        color: #fff; /* 悬停时金色文字 */
      }

      &:active {
        transform: translateY(1px); /* 点击时轻微下移 */
      }

      &:active {
        box-shadow: 0 2px 4px rgba(0, 94, 217, 0.3); /* 点击时减少阴影 */
      }

      &:focus {
        outline: none; /* 移除默认轮廓 */
        box-shadow: 0 0 0 3px rgba(0, 94, 217, 0.3); /* 自定义焦点样式 */
      }
    }
  }
}

.input-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  /* 避免撑高为两行：不强制占满父元素高度 */
  height: auto;
}
/deep/ .doctorAdviceInput  .el-textarea__inner{
  color: #3973b6 !important;
}
/deep/.el-form-item{
  margin: 0;
  margin-bottom: 2px;
}
/deep/.el-form-item__content{
  margin: 0 !important;
}
/deep/.el-input__inner{
  text-align: right;
  height: 30px;
  border-radius: 0;
  border-top: none;
  border-right: none;
  border-left: none;
  line-height: 41px;
  //border: 1px solid red;
}

// 上传弹框样式
.uploadOptions {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;

  .uploadOption {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 20px;
    border: 2px solid #e4e7ed;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
    min-width: 120px;

    i {
      font-size: 40px;
      color: #606266;
    }

    span {
      font-size: 14px;
      color: #303133;
    }

    &:hover {
      border-color: #409eff;
      background-color: #f0f9ff;

      i, span {
        color: #409eff;
      }
    }
  }
}

.uploadTip {
  text-align: center;
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
}
.yfBox{
  position: relative;
  .noneMarsk{
    position: absolute;
    top: -36px;
    width: 100%;
    height: 117%;
    //background-color: red;
    z-index: 999;
  }
}
.AIyfTip{
  width: 97%;
  height: 40px;
  border: 1px solid var(--error-color) !important;
  background-color: var(--error-color2) !important;
  color: var(--error-color);
  display: flex;
  align-items: center;
  //justify-content: center;
  padding-left: 20px;
  margin: 15px;
  border-radius: 5px;
}
/deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus{
  border: 1px solid var(--error-color) !important;
  background-color: var(--error-color2) !important;
}
/deep/.el-form-item__error {
  font-size: 12px;
  line-height: 1;
  position: absolute;
  top: -59%;
  left: 11%;
  background: var(--error-color);
  padding: 7px;
  border-radius: 3px;
  color: #fff;
}
.must{
  color: red;
  font-size: 18px;
  font-weight: 900;
}
/deep/ .el-form-item{
  height: 100%;
  margin-bottom: 0;
}
::-webkit-scrollbar {
  width: 10px;
  background-color: transparent;
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
}
</style>
